import { FieldArray, Formik, useFormikContext } from "formik";
import React, { useEffect, useState, useRef } from "react";
import "./backtoschedules.css";
import { initialValues, getInitialValues } from "./data";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import MultipleDatePicker from "react-multiple-datepicker";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getProfileBasicInfo } from "../../../../services/medium";
import { getAllTopic } from "../../../../services/admin";
import { toast } from "react-toastify";
import ConfirmSessionCurrency from "../../appointments/subcomponents/sessioncurrency";
import AvailabilityNotePopup from "./availabilityNotePopup";
import {
  makeHours,
  updateSingleMediumAvailability,
  addScheduleForm,
  updateScheduleForm,
  setAdvancedAvailability,
  clearScheduleForm,
  setMediumAvailability,
} from "../functions";
import {
  checkAlreadyExistService,
  getAdvancedPreferences,
  getAdvancedPreferencesFromAdmin,
  setNewTimeZone,
} from "../../../../services/medium";
import {
  filterVisibleTimeZones,
  removeItemOnce,
  toolbar,
} from "../../../../utils/helpers";
import {
  capitalizeFirstLetter,
  participantLevelRoles,
  studentLevelRoles,
  getTimeImage,
} from "../../../../utils/utils";
import moment, { duration } from "moment";
import { setTimezoneArray } from "../../../../reducer/uidataSlice";
import { getTimezones } from "../../../../services/uidata";
import { setNewTimeZoneData } from "../../../../reducer/userSlice";
import { slotsArray, case10Array, items } from "../data";
import { setFilteredData } from "../../../../reducer/adminSlice";
import BookingPeriodBar from "../bookingperiodbar";
import ConfirmOffline from "../subcomponent/checkOffline";

import ConfirmTime from "../subcomponent/confirmTime";

import PreviewCheckbox from "../subcomponent/previewcheckbox";
import { tr } from "date-fns/locale";


//desc
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, convertFromRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { filter } from "pusher-js";
import {getSessionPrice, getMediumCurrency} from "../../../../../src/services/admin.js"
import { get } from "immutable";
import { useTranslation } from "react-i18next";

export default function BackToSchedules({
  type = "admin",
  formType,
  openSchedules,
  medium_id,
  countries,
  topic,
  schedule_id = "",
  isCopyType = 0,
  profilePreferences = [],
  languages = [],
}) {
  const { t } = useTranslation("mediumSchedule");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectRef = useRef();
  const { timezone, current_mediumship_level, is_pay_forward, session_currency,id: userId } = useSelector((state) => state.user.user);
  const [valueupdated, setValueUpdated] = useState(true);
  const auth = useSelector((state) => state.auth);
  const { timezoneArray, countryArray } = useSelector((state) => state.uidata);
  const { sessionTypes, screenNameDetails } = useSelector((state) => state.users);
  const [collapsed, setCollapsed] = useState("collapse");
  const [newCountryData, setNewCountryData] = useState([]);
  const [newTopic, setNewTopic] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [update, setUpdate] = useState({});
  const [values, setValues] = useState(() => getInitialValues());
  const [isValueLoded, setisValueLoded] = useState(false);
  const [copydays, setcopydays] = useState([]);
  const [activeCopy, setActiveCopy] = useState("");
  const [mediumRolesStudentList, setmediumRolesStudent] = useState([]);
  const [mediumRolesList, setmediumRoles] = useState([]);
  const [showField, setshowField] = useState(false);
  const [timezoneData, setTimezoneData] = useState([]);
  const [mediumAvailabilityId, setmediumAvailabilityId] = useState("");
  const [slotsList, setSlotsList] = useState([]);
  const [ParticipantLevelStatus, setParticipantLevelStatus] = useState(false);
  //specific dates
  const [testValues, settestValues] = useState([]);
  const [updateType, setUpdateType] = useState("ADD");
  const [updateTypeIndex, setUpdateTypeIndex] = useState(0);

  //blocked dates
  const [blockedDatesValues, setBlockedDatesValues] = useState([]);
  const [blockedupdateType, setUpdateblockedType] = useState("ADD");
  const [blockedupdateTypeIndex, setblockedUpdateTypeIndex] = useState(0);

  //
  const [showSpecificAddDates, setShowSpecificAddDates] = useState(false);
  const [showBlockedAddDates, setShowBlockedAddDates] = useState(false);

  //
  const [blockedfullday, setBlockedFullday] = useState(false);
  const [specificfullday, setspecificFullday] = useState(false);
  const [errorMessages, setErrorMessages] = useState({})

  const [alreadyExist, setAlreadyExist] = useState(false);
  const [active60minNote, setActive60minNote] = useState(false);
  const [alreadyExistService, setAlreadyExistService] = useState('');
  const [unitValue, setUnitValue] = useState('Days')
  const [temporaryStorage, setTemporaryStorage] = useState()

  const [activeSessionLength, setactiveSessionLength] = useState();
  const [searchParams] = useSearchParams();
  const level = type === "admin" ? parseInt(searchParams.get("level")) : parseInt(current_mediumship_level)

  const [showGroupSession, setShowGroupSession] = useState(false);
  const [show30Min, setShow30Min] = useState(false);
   const [showMuliLanguage, setShowMuliLanguage] = useState(true);
  const [showPayForward, setShowPayForward] = useState(false);
  const [showDevelopmentCircles, setDevelopmentCircles] = useState(false);
  
  const [showGroupNotification, setshowGroupNotification] = useState(false);
  const [showGroup, setshowGroup] = useState(true);

  const [showpreffered, setshowpreffered] = useState(false);
  const [timeDifferenceError, setTimeDifferenceError] = useState(false);
  const [disablePreferredType, setdisablePreferredType] = useState(true);
  const [showNoOfSesionPerDay, setshowNoOfSesionPerDay] = useState(true);
  const [formBody, setFormBody] = useState(null);
  const [userCurrency, setuserCurrency] = useState("USD");
  const [priceForAttendee, setPriceForAttendee] = useState(true);
  const [additionalWorker, setAdditionalWorker] = useState(false);
  const [topicShow, setTopicShow] = useState(false);
  const [evnetInfo, setEvnetInfo] = useState(false);
  const [WeeklyGroupEvents, setWeeklyGroupEvents] = useState(false);
  const [clientMediumAttendees, setClientMediumAttendees] = useState(false);

  const subSessionIds=[29, 41, 42, 43, 44, 45, 46, 80, 81, 82, 83, 84, 85, 86, 90, 92, 94, 98,79,80,88,89,90
,83,84,85,86]

  const getPrice = async (subSessionId,setFieldValue) => {
    if(schedule_id === ''){
      const resp = await getSessionPrice(subSessionId, medium_id)
      const price = resp.data.price ? resp.data.price : "";
      setFieldValue("price_for_attendees", price)
    }
  }

// useEffect(() => {

// }, [isValueLoded]);
const getCurrency = async () => {
    const resp = await getMediumCurrency(medium_id)
    const currency = resp.data.currency ? resp.data.currency : null;
    initialValues.session_currency = currency !== "" &&
      currency !== null
      ? Object.values(JSON.parse(currency))[0] !== "" ? Object.values(JSON.parse(currency))[0] : "USD"
      : "USD";
    setuserCurrency(initialValues.session_currency);
}
  useEffect(() => {
    getCurrency();
 
    // initialValues.session_currency = session_currency !== "" &&
    //   session_currency !== null
    //   ? Object.values(JSON.parse(session_currency))[0] !== "" ? Object.values(JSON.parse(session_currency))[0] : "USD"
    //   : "USD";
    // setuserCurrency(initialValues.session_currency);


    // getProfileBasicInfo()
    // .then((data) => {

    // })
    // .catch((err) => console.log(err));
    getAllTopic()
      .then((data) => {
        setNewTopic(data.data.data);
      })
      .catch((err) => console.log(err));
    if (is_pay_forward == true) {

      setShowPayForward(true);
    } else {
      setShowPayForward(false);
    }
    // if(info.main_info.session_currency !== "" && info.main_info.session_currency !== null){
    //   initialValues.session_currency = info.main_info.session_currency;
    // }
    setTimeout(() => {
    }, 5000)
    clearScheduleForm(initialValues);
    if (schedule_id === "") {
      initialValues.start_date = moment(new Date()).format("YYYY-MM-DD");
    }
    setSlotsList(
      slotsArray.map((data) => {
        return {
          label: data.time,
          value: data.time,
          image: data.image,
          val: data.val,
          change: data.change,
        };
      })
    );
    if (!timezoneArray.length) updateTimezones();
  }, []);
  useEffect(() => {
    setTimezoneData(filterVisibleTimeZones(timezoneArray));
  }, [timezoneArray]);

  const updateTimezones = () => {
    getTimezones()
      .then((data) => {
        dispatch(setTimezoneArray(data.data.data));
      })
      .catch((err) => console.log(err));
  };
  const changeTimeZoneHandler = (e) => {
    let id = e.target.value;
    let body = {
      timezone_id: id,
    };
    setNewTimeZone(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(setNewTimeZoneData(filterTimeZone(id)));
        }
      })
      .catch(() => { });
  };



  const handleMinDaysChange = (e, setFieldValue) => {
    setFieldValue("min_booking_days", e.target.value);
    setFieldValue("min_booking_hour", "00");
    setFieldValue("min_booking_time", "00");
  }

  const handleMinHoursChange = (e, setFieldValue) => {
    setFieldValue("min_booking_hour", e.target.value);
    setFieldValue("min_booking_days", "00");
    setFieldValue("min_booking_time", "00");
  }

  const handleMinTimeChange = (e, setFieldValue) => {
    setFieldValue("min_booking_time", e.target.value);
    setFieldValue("min_booking_hour", "00");
    setFieldValue("min_booking_days", "00");
  }


  const filterTimeZone = (id) => {
    let zone;
    timezoneData.filter((item) => {
      if (parseInt(id) === parseInt(item.id)) {
        zone = item.front_name;
      }
    });
    return zone;
  };

  useEffect(() => {
    if (type === "admin") {
      setSessions(sessionTypes);
    } else {
      setSessions(
        sessionTypes.map((item) => {
          return {
            value: item.sub_session_id,
            label: item.sub_session_name,
            session_type: item.session_type,
            sub_session_id: item.sub_session_id,
            is_group_session: item.is_group_session,
            display_mediumship_level_checkboxes: item.display_mediumship_level_checkboxes,
            enable_mediumship_level_selection: item.enable_mediumship_level_selection,
            duration: item.duration
          };
        })
      );
    }

    if (schedule_id !== "") {
      setmediumAvailabilityId(schedule_id);
      setUpdate({});
      setisValueLoded(false);
      setValues(getInitialValues());
      updateSingleMediumAvailability(schedule_id, updateForm, level);

      // initialValues.start_date = '2023-01-19';
    }
    if (schedule_id === "") {
      getAdvancedProfile();

      // initialValues.start_date = '2023-01-19';
    }

    setmediumRolesStudent(
      studentLevelRoles.map((item) => {
        return { value: item.id, label: item.name };
      })
    );
    setmediumRoles(
      participantLevelRoles.map((item) => {
        return { value: item.id, label: item.name };
      })
    );

    setNewCountryData(
      countries.map((item) => {
        return {
          ...item,
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [countries, schedule_id, sessionTypes]);

  const getAdvancedProfile = async () => {

    if (type === "admin") {
      await getAdvancedPreferencesFromAdmin(medium_id)
        .then((data) => {
          let profilePrefer = data.data.data;
          addNewData(profilePrefer);
          //addScheduleForm(initialValues,profilePreferences);
        })
        .catch((err) => console.log(err));
    }
    else {

      await getAdvancedPreferences()
        .then((data) => {
          let profilePrefer = data.data.data;
          addNewData(profilePrefer);
          //addScheduleForm(initialValues,profilePreferences);
        })
        .catch((err) => console.log(err));
    }
  };

  const addNewData = (profilePrefer) => {
    const baseValues = getInitialValues();
    addScheduleForm(baseValues, profilePrefer, countries);
    setValues(baseValues);
    setisValueLoded(true);
  };

  const cancelForm = () => {
    setValues(getInitialValues());
    openSchedules();
  };
  const updateForm = (info) => {

    if (info.main_info.session_type == 99 || info.main_info.session_type == 101) {
      setAdditionalWorker(true);
      if(info.main_info.session_type == 101){
        setClientMediumAttendees(true);
      }
    } else {
      setAdditionalWorker(false);
      setClientMediumAttendees(false);
    }

    if (info.main_info.sub_session_type == 96) {
      setTopicShow(true);
      setPriceForAttendee(false)
    } else if(info.main_info.sub_session_type == 93){
      setPriceForAttendee(false)
    } else {
      setTopicShow(false);
      setPriceForAttendee(true)
    }

    if (info.main_info.sub_session_type == process.env.REACT_APP_COACHING_30_Minute_Session || subSessionIds.includes(info.main_info.sub_session_type)) {
      initialValues.price_for_attendees = info.main_info.price_for_attendees ;
      setShow30Min(true);
      setDevelopmentCircles(true);
      setPriceForAttendee(true)
    }

    else {
      setShow30Min(false);
      setDevelopmentCircles(false);
    }
    if(info.main_info.sub_session_type == process.env.REACT_APP_COACHING_GROUP_SESSION_ID){
      setDevelopmentCircles(false);
    }
    // if (info.main_info.session_currency == 99) {
    //   setAdditionalWorker(true);
    // }else {
    //   setAdditionalWorker(false);
    // }

    if (info.main_info.is_group_session == 1) {
      setShowGroupSession(true);
      setShow30Min(true);


      initialValues.price_for_attendees = info.main_info.price_for_attendees;
      initialValues.additional_worker = info.main_info.additional_worker;
      initialValues.topic = info.main_info.topic;
      if(info.main_info.sub_session_type == 93 || info.main_info.sub_session_type == 94 || info.main_info.sub_session_type == process.env.REACT_APP_COACHING_GROUP_SESSION_ID || info.main_info.sub_session_type == 96 || info.main_info.sub_session_type == 98){
            setShowMuliLanguage(false);
          }

    } else {
      setShowGroupSession(false);

    }
    setUpdate(info);
  };

  const submitForm = (body) => {

    // if(body.specificDateSlotsdata === "[]" && )
    // if (body.end_date !== "" && body.end_date !== null) {
    //   let specific = body.specificDateSlotsdata
    //   let block = body.blockedSpecificSlotsData
    //   let end = moment(body.end_date, "YYYY-MM-DD").add(1, "days").format('YYYY-MM-DD')
    //   let specificcheck = JSON.parse(specific).every((data) => {
    //     return moment(end).isAfter(data.date)
    //   })
    //   let blockdate = JSON.parse(block).every((data) => {
    //     return moment(end).isAfter(data.date)
    //   })
    //   if (!specificcheck) {
    //     toast.error("Please Select Specific Dates Between start date and end date ", { position: "top-center" });
    //     return true
    //   }
    //   if (!blockdate) {
    //     toast.error("Please Select blocked Dates Between start date and end date ", { position: "top-center" });
    //     return true
    //   }

    // }
    setAdvancedAvailability(
      body,
      setmediumAvailabilityId,
      dispatch,
      openSchedules
    );
  };
  useEffect(() => {
    if (Object.values(update).length > 0) {
      let countryType = getCountryTypes(
        values.country_type,
        values.exclusions,
        values.inclusions
      );
      updateScheduleForm(
        update,
        initialValues,
        sessions,
        type,

        setValues,
        languages,
        newCountryData,
        settestValues,
        setBlockedDatesValues
        , setUnitValue,
        level,
        setDevelopmentCircles,
        setShowSpecificAddDates,
        setshowGroupNotification,
        setshowpreffered,
        setshowNoOfSesionPerDay,
        setdisablePreferredType,
        sessionTypes,
        setPriceForAttendee,
        setAdditionalWorker,
        setEvnetInfo,
        setClientMediumAttendees,
        setWeeklyGroupEvents,
        isCopyType
      );
      setisValueLoded(true);
      // setValues(initialValues)
    }
  }, [update]);

  function isHTML(str) {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }
  useEffect(() => {
    if (Object.keys(update).length > 0) {
      setTimeout(() => {

       var rawContentFromDB =
                            update &&
                            update.main_info &&
                            update.main_info.meta_data &&
                            typeof update.main_info.meta_data.description !== 'undefined'
                            ? update.main_info.meta_data.description
                            : undefined;
        if (rawContentFromDB !== undefined) {
          let html;
          if (!isHTML(rawContentFromDB)) {
            let info =
              rawContentFromDB
                .split("\n")
                .map(line => `<p>${line}</p>`)
                .join("");
            html = info
          }
          else {

            html = JSON.parse(rawContentFromDB).content
          }
          const blocksFromHtml = htmlToDraft(html);
          const contentState = ContentState.createFromBlockArray(
            blocksFromHtml.contentBlocks
          );
          setEditorState(EditorState.createWithContent(contentState));
        }
      }, 2000);
    }
    // setEditorState(stepOneData.biographicalInfo)
  }, [update]);
  const copyChangeHandler = (e) => {
    let data = copydays;
    if (e.target.checked) {
      data.push(e.target.value);
    } else {
      let index = data.indexOf(e.target.value);

      if (index > -1) {
        data.splice(index, 1);
      }
    }
    setcopydays(data);
  };
  const copyHandler = (data, setFieldValue) => {

    let newvalues = data;
    copydays.map((day) => {
      if (activeCopy === "sunday") {
        newvalues.daysunday = true;
        runDaysFunc(day, newvalues, data.scheduleSunday, setFieldValue);
      }
      if (activeCopy === "monday") {
        newvalues.daymonday = true;
        runDaysFunc(day, newvalues, data.scheduleMonday, setFieldValue);
      }
      if (activeCopy === "tuesday") {
        newvalues.daytuesday = true;
        runDaysFunc(day, newvalues, data.scheduleTuesday, setFieldValue);
      }
      if (activeCopy === "wednesday") {
        newvalues.daywednesday = true;
        runDaysFunc(day, newvalues, data.scheduleWednesday, setFieldValue);
      }
      if (activeCopy === "thursday") {
        newvalues.daythursday = true;
        runDaysFunc(day, newvalues, data.scheduleThursday, setFieldValue);
      }
      if (activeCopy === "friday") {
        newvalues.dayfriday = true;
        runDaysFunc(day, newvalues, data.scheduleFriday, setFieldValue);
      }
      if (activeCopy === "saturday") {
        newvalues.daysaturday = true;
        runDaysFunc(day, newvalues, data.scheduleSaturday, setFieldValue);
      }
    });
    setisValueLoded(false);
    setValues(newvalues);
    setCollapsed("collapse show");
    setTimeout(() => {
      setisValueLoded(true);
      setcopydays([]);
    }, 10);
  };

  const runDaysFunc = (day, info, data, setFieldValue) => {
    let newdata = JSON.parse(JSON.stringify(data))
    if (day === "sunday") {
      info.daysunday = true;
      info.scheduleSunday = newdata;
      // setFieldValue('scheduleSunday', data)

    }
    if (day === "monday") {

      info.daymonday = true;
      // setFieldValue('scheduleMonday', data)
      info.scheduleMonday = newdata;
    }
    if (day === "tuesday") {
      info.daytuesday = true;
      // setFieldValue('scheduleTuesday', data)
      info.scheduleTuesday = newdata;
    }
    if (day === "wednesday") {
      info.daywednesday = true;
      // setFieldValue('scheduleWednesday', data)
      info.scheduleWednesday = newdata;
    }
    if (day === "thursday") {
      info.daythursday = true;
      // setFieldValue('scheduleThursday', data)
      info.scheduleThursday = newdata;
    }
    if (day === "friday") {
      info.dayfriday = true;
      // setFieldValue('scheduleFriday', data)
      info.scheduleFriday = newdata;
    }
    if (day === "saturday") {
      info.daysaturday = true;
      // setFieldValue('scheduleSaturday', data)
      info.scheduleSaturday = newdata;
    }
    setcopydays([])
  };
  const changeHandler = async(e, setFieldValue, values) => {
    let value = e.target.value;
    let filtered = sessions.filter((item) => item.sub_session_id == value)
    if (type === "admin") {

      //NEW CODE
      if (filtered.length > 0) {
        if(filtered[0].sub_session_id == 93 || filtered[0].sub_session_id == 94 || filtered[0].sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID || filtered[0].sub_session_id == 96 || filtered[0].sub_session_id == 98){
            setShowMuliLanguage(false);

          }
          if(filtered[0].sub_session_id == process.env.REACT_APP_COACHING_30_Minute_Session || subSessionIds.includes(filtered[0].sub_session_id )){
            getPrice(filtered[0].sub_session_id,setFieldValue)
            setShow30Min(true);
            setPriceForAttendee(true)
            setDevelopmentCircles(true);
          }else{
            setShow30Min(false);
            setDevelopmentCircles(false);
          }
          if(filtered[0].sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID){
            setDevelopmentCircles(false);
          }

        if (filtered[0].is_group_session == 1) {
          setshowGroupNotification(true)
          setShowGroupSession(true);
          setShow30Min(true);
          setshowpreffered(true);
          setShowSpecificAddDates(true)
          setshowNoOfSesionPerDay(false)
          if (filtered[0].sub_session_name == "Coached Practice Circles") {
            setDevelopmentCircles(true);
          }
        }
        else {

        }
        if (filtered[0].display_mediumship_level_checkboxes == 1) {
          setshowpreffered(true);
        }
        else {
          setshowpreffered(false);
        }

        if (filtered[0].enable_mediumship_level_selection == 0) {
          setdisablePreferredType(true)
        }
        else {
          setdisablePreferredType(false)
        }

        if (filtered[0].sub_session_id == 95) {
          setEvnetInfo(true)
          setWeeklyGroupEvents(true)
          setPriceForAttendee(true)
        } else if (filtered[0].sub_session_id == 101) {
          setEvnetInfo(true)
          setWeeklyGroupEvents(false)
          setClientMediumAttendees(true);
          // setPriceForAttendee(true)
        } else if (filtered[0].sub_session_id == 93) {
          setEvnetInfo(true)
          setWeeklyGroupEvents(false)
          setClientMediumAttendees(false);
          setPriceForAttendee(false)
        } else if (filtered[0].sub_session_id == 94 || filtered[0].sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID) {
          setEvnetInfo(true)
          setWeeklyGroupEvents(false)
          setClientMediumAttendees(false);
        } else {
          setEvnetInfo(false)
          setWeeklyGroupEvents(false)
          setClientMediumAttendees(false);
          setPriceForAttendee(true)
        }
        if (filtered[0].sub_session_id == 99 || filtered[0].sub_session_id == 101) {
          if(filtered[0].sub_session_id == 101){
            setClientMediumAttendees(true)
          }
          setAdditionalWorker(true);
        } else {
          setAdditionalWorker(false);
          setClientMediumAttendees(false);
        }

        if (filtered[0].sub_session_id == 96) {
          setTopicShow(true)
          setPriceForAttendee(false)
        }
        else {
          setTopicShow(false)
          setPriceForAttendee(true)
        }
        // if (filtered[0].sub_session_id == 99) {
        //   setAdditionalWorker(true);
        // }
        // else {
        //   setAdditionalWorker(false);
        // }
        if(filtered[0].sub_session_id == 93){
           setPriceForAttendee(false)
        }
      }
      else {
        setshowGroupNotification(false)
        setShowGroupSession(false);
        setShowMuliLanguage(true);
        setDevelopmentCircles(false);
        setshowpreffered(false);
        setShowSpecificAddDates(false)
        setshowNoOfSesionPerDay(true)
        setEvnetInfo(false)
        setPriceForAttendee(true)
        setAdditionalWorker(false);
        setShow30Min(false);
      }

      /// NEW CODE
    }

    //
    let find_data = sessions.filter((item) => {
      if (parseInt(item.sub_session_id) === parseInt(value)) {
        return item;
      }
    });
    if (parseInt(find_data[0].participant_level) === 1) {
      setParticipantLevelStatus(true);
    } else {
      setParticipantLevelStatus(false);
    }
    if (parseInt(find_data[0].student_level) === 1) {
      setshowField(true);
    } else {
      setshowField(false);
    }

    setFieldValue("is_group_session", find_data[0].is_group_session)
    setFieldValue("session_type", value);
  };
  const removefirstArray = (item, setFieldValue) => {
    setFieldValue(item, [{ from: "", to: "" }]);
  };

  const removefirstArrayDateSLots = (item, setFieldValue) => {
    setFieldValue(item, [
      { date: "", time: [{ from: "", to: "", time_slot_id: "" }] },
    ]);
    if (item === "specificDateSlots") {
      setspecificFullday(false);
    }
    else {
      setBlockedFullday(false);
    }

  };

  // const removefirstArraySpecificslots = (item, setFieldValue) => {
  //   setFieldValue(item,[{date:"",time:[{from: "", to: "",time_slot_id:""}]}]);
  // };
  const handleTime = (time) => {

    let times = time.map((item) => {
      return {
        from:
          item.from !== ""
            ? item.from.change !== "NO"
              ? formatTimeTo24hrs(item.from.value)
              : "24:00"
            : "",
        to:
          item.to !== ""
            ? item.to.change !== "NO"
              ? formatTimeTo24hrs(item.to.value)
              : "24:00"
            : "",
      };
      // removeString()
    });
    let timed = times.map((item) => { return [item.from, item.to] })
    let newTime = timed.sort(([a], [b]) => a < b ? -1 : 1);
    let updatedTime = newTime.map((item) => {
      return {
        from: item[0],
        to: item[1]
      }
    })
    return updatedTime;
  };
  const handleTime1 = (time) => {
    let times = time.map((item) => {
      return {
        from:
          item.from !== ""
            ? item.from.change !== "NO"
              ? formatTimeTo24hrs(item.from.value)
              : "24:00"
            : "",
        to:
          item.to !== ""
            ? item.to.change !== "NO" && item.to.label !== "12:00 AM"
              ? formatTimeTo24hrs(item.to.value)
              : "24:00"
            : "",
      };

      // removeString()
    });
    let timed = times.map((item) => { return [item.from, item.to] })
    let newTime = timed.sort(([a], [b]) => a < b ? -1 : 1);
    let updatedTime = newTime.map((item) => {
      return {
        from: item[0],
        to: item[1]
      }
    })
    return updatedTime;
  };
  // const handleSpecificDateslots=(data)=>{
  //   let dateslot=data.map((item)=>{
  //    return{
  //     date:item.date,
  //     time:item.time.map((dataItem)=>{
  //       return handleTime(dataItem);
  //     })
  // }})
  // return dateslot;
  // }
  const formatTime = (item) => {
    return moment(`${item}:00`, ["hh:mm"]).format("hh:mm A");
  };

  const formatTimeTo24hrs = (item) => {
    return moment(`${item}`, "hh:mm A").format("HH:mm");
  };

  const getCountryTypes = (type, exclusions, inclusions) => {
    let country;
    if (type === "All Countries") {
      country = newCountryData.map((item) => {
        return item.value;
      });
    }
    if (type === "All Countries with Exclusions") {
      let itemArray = [];

      newCountryData.map((item, index) => {
        itemArray.push(item.value);
      });
      exclusions.map((item, index) => {
        itemArray = removeItemOnce(itemArray, item.value);
      });
      country = itemArray;
    }
    if (type === "Selected Countries only") {
      country = inclusions.map((item) => {
        return item.value;
      });
    }

    return country;
  };

  const changeSigleSession = async(value, setFieldValue, values) => {
    if (value.length) {

      setFieldValue('is_group_session', value[0].is_group_session);
    }
    let filtered = value.filter((item) => {
      if (item.label.includes("60")) {
        return item;
      }
    })
    if (filtered.length) {
      setActive60minNote(true)
    }
    else {
      setActive60minNote(false)
    }


    let array = value;
    const hasValue = array.some(obj => obj.is_group_session === 1);
    const hasDifferentValues = array.some(obj => obj.is_group_session !== 1);
    if (hasDifferentValues && hasValue) {
      array = array.filter(obj => obj.is_group_session !== 1);
    }

    value = array;

    setTopicShow(false)
    //NEW CODE
    if (value.length > 0) {

      if(value[0].sub_session_id == 93 || value[0].sub_session_id == 94 || value[0].sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID ||value[0].sub_session_id == 96 ||value[0].sub_session_id == 98){
            setShowMuliLanguage(false);
            initialValues.meeting_preferences_meeting =[{value: 11, label: 'English'}]
      }
      if(value[0].sub_session_id == process.env.REACT_APP_COACHING_30_Minute_Session || subSessionIds.includes(value[0].sub_session_id)){
        getPrice(value[0].sub_session_id,setFieldValue)
        setShow30Min(true);
        setDevelopmentCircles(true);
      }else{
        setShow30Min(false);
        setDevelopmentCircles(false);
      }
      if(value[0].sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID){
        setDevelopmentCircles(false);
      }
      if (value[0].is_group_session == 1) {
        setshowGroupNotification(true)
        setShowGroupSession(true);
        setShow30Min(true);
        setshowpreffered(true);
        setShowSpecificAddDates(true)
        setshowNoOfSesionPerDay(false)
        if (value[0].sub_session_id == 96) {
          setPriceForAttendee(false);
          setTopicShow(true)
        } else if (value[0].sub_session_id == 93){
          setPriceForAttendee(false);
        } else {
          setPriceForAttendee(true);
          setTopicShow(false)
        }
        if(value[0].sub_session_id == 101 || value[0].sub_session_id == 95 || value[0].sub_session_id == 93 || value[0].sub_session_id == 94 || value[0].sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID){
          setEvnetInfo(true)
          if(value[0].sub_session_id == 101){
            setClientMediumAttendees(true);
          }
        }else{
          setEvnetInfo(false)
          setClientMediumAttendees(false);
        }
        if (value[0].sub_session_id == 99 || value[0].sub_session_id == 101) {
          setAdditionalWorker(true);
        } else {
          setAdditionalWorker(false);
        }
        if (value[0].label == "Coached Practice Circles") {
          setDevelopmentCircles(true);
        }
      }
      else {

      }
      if (value[0].display_mediumship_level_checkboxes == 1) {
        setshowpreffered(true);
      }
      else {
        setshowpreffered(false);
      }

      if (value[0].enable_mediumship_level_selection == 0) {
        setdisablePreferredType(true)
      }
      else {
        setdisablePreferredType(false)
      }
    }
    else {
      setshowGroupNotification(false)
      setShowGroupSession(false);
      setShow30Min(false);
      setShowMuliLanguage(true);
      setDevelopmentCircles(false);
      setshowpreffered(false);
      setShowSpecificAddDates(false)
      setshowNoOfSesionPerDay(true)
      setAdditionalWorker(false);
      setShow30Min(false);
    }

    /// NEW CODE







    let getId = value[value.length - 1]
    let body = {
      sub_session_id: getId ? getId.sub_session_id : 0
    }
    checkAlreadyExistService(body).then((data) => {
      if (data.data.data === 0) {

        setAlreadyExist(false);
        setFieldValue("session_type", value);
        setAlreadyExistService()
        setactiveSessionLength(value[0].session_type)






        // if (value.length > 0) {
        //   let info = value.filter((item) => parseInt(item.is_group_session) === 1)
        //   if (info.length > 0) {

        //     checkTypeOfMedium(value, setFieldValue, values);

        //   }
        //   else {
        setFieldValue('preferred_medium_level', ["1", "2", "3", "4", "5", "6", "7"])
        //   }
        // }

      }
      else {

        setAlreadyExistService(getId.label)
        setAlreadyExist(true);
      }
    }).catch(() => {

    })
    // setFieldValue("session_type", value);
    const checkUsername = (obj) => parseInt(obj.session_type) === 2;
    if (value.some(checkUsername)) {
      setParticipantLevelStatus(true);
    } else {
      setParticipantLevelStatus(false);
    }
  };

  //specific dates
  const updatdeValues = (info, setFieldValue, body) => {
    //     let end = moment(body.end_date, "YYYY-MM-DD").add(1, "days").format('YYYY-MM-DD')

    // if (body.end_date !== "" && body.end_date !== null) {
    let specific = body.specificDateSlots
    let end = moment(body.end_date, "YYYY-MM-DD").add(1, "days").format('YYYY-MM-DD');
    let start = moment(body.start_date, "YYYY-MM-DD").subtract(1, "days").format('YYYY-MM-DD');
    let specificcheck = specific.every((data) => {
      return ((end !== "" && end !== "Invalid date") ? moment(end).isAfter(data.date) : true) && (start !== "" && moment(start).isBefore(data.date))
    })
    if (!specificcheck) {
      toast.error(t("toasts.specificDatesBetween"), { position: "top-center" });
      return true
    }

    // }
    if (updateType === "ADD") {
      let aa = testValues;
      aa.push(info[0]);

      settestValues(aa);
    }
    if (updateType === "EDIT") {
      let aa = testValues;
      aa[updateTypeIndex] = info[0];
      settestValues(aa);
    }
    setUpdateType("ADD");
    setFieldValue("specificDateSlots", [
      { date: "", time: [{ from: "", to: "", time_slot_id: "" }] },
    ]);
    setspecificFullday(false)
  };

  const getCopiedDates = (dates, index, setFieldValue) => {
    let info = testValues;

    dates.map((date) => {
      info.push({
        date: moment(date).format("YYYY-MM-DD"),
        time: testValues[index].time,
      });
    });
    settestValues(info);
    setFieldValue("specificDateSlots", [
      { date: "", time: [{ from: "", to: "", time_slot_id: "" }] },
    ]);
  };
  const onDeleteSpecificValue = (index, setFieldValue) => {
    let array = testValues;
    if (index > -1) {
      array.splice(index, 1);
    }
    settestValues(array);
    setFieldValue("specificDateSlots", [
      { date: "", time: [{ from: "", to: "", time_slot_id: "" }] },
    ]);
  };

  const onEditSpecificValue = (index, setFieldValue) => {
    setUpdateType("EDIT");
    setFieldValue("specificDateSlots", [testValues[index]]);
    setUpdateTypeIndex(index);
    // setblockedUpdateTypeIndex(index);
    setShowSpecificAddDates(true);
  };

  //blocked dates
  const getBlockedCopiedDates = (dates, index, setFieldValue) => {
    let info = blockedDatesValues;

    dates.map((date) => {
      info.push({
        date: moment(date).format("YYYY-MM-DD"),
        time: blockedDatesValues[index].time,
      });
    });
    setBlockedDatesValues(info);
    setFieldValue("blockedDateSlots", [
      { date: "", time: [{ from: "", to: "", time_slot_id: "" }] },
    ]);
  };
  const onEditBlockedValue = (index, setFieldValue) => {
    setUpdateblockedType("EDIT");
    setFieldValue("blockedDateSlots", [blockedDatesValues[index]]);
    // setUpdateTypeIndex(index);
    setblockedUpdateTypeIndex(index);
    setShowBlockedAddDates(true);
  };
  const updatdeBlockedValues = (info, setFieldValue, body) => {

    // if (body.end_date !== "" && body.end_date !== null) {
    let block = body.blockedDateSlots
    let end = moment(body.end_date, "YYYY-MM-DD").add(1, "days").format('YYYY-MM-DD');
    let start = moment(body.start_date, "YYYY-MM-DD").subtract(1, "days").format('YYYY-MM-DD');
    let blockdate = block.every((data) => {
      return ((end !== "" && end !== "Invalid date") ? moment(end).isAfter(data.date) : true) && (start !== "" && moment(start).isBefore(data.date))
    })

    // if (!blockdate) {
    //   toast.error("Please Select blocked Dates Between start date and end date ", { position: "top-center" });
    //   return true
    // }

    // }
    if (blockedupdateType === "ADD") {
      let aa = blockedDatesValues;
      aa.push(info[0]);
      setBlockedDatesValues(aa);
    }
    if (blockedupdateType === "EDIT") {
      let aa = blockedDatesValues;
      aa[blockedupdateTypeIndex] = info[0];
      setBlockedDatesValues(aa);
    }
    setUpdateblockedType("ADD");
    setFieldValue("blockedDateSlots", [
      { date: "", time: [{ from: "", to: "", time_slot_id: "" }] },
    ]);
    setBlockedFullday(false)
  };
  const onDeleteBlockedValue = (index, setFieldValue) => {
    let array = blockedDatesValues;
    if (index > -1) {
      array.splice(index, 1);
    }
    setBlockedDatesValues(array);
    setFieldValue("blockedDateSlots", [
      { date: "", time: [{ from: "", to: "", time_slot_id: "" }] },
    ]);
  };
  function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
  }

  const customFilter = (option, searchText) => {
    // const check = (option, searchText) => {

    let searchingtime = option.data.value === "11:59 PM" ? "12:00 AM" : option.data.value;
    let status = true;
    if (searchText !== "") {
      let case1 = searchingtime.indexOf("0") === 0;
      let case2 = searchingtime.indexOf("1") === 0;
      let case10 = searchingtime.indexOf("1") === 0 && searchingtime.indexOf("0") === 1 && case10Array.includes(searchingtime.replaceAll(':', "").replaceAll(" ", ""));

      let newSearchTime = searchText.replaceAll(":", "").replaceAll(" ", "");
      if (newSearchTime[0] === "1" && newSearchTime[1] === "0" && newSearchTime[2] === "1" || newSearchTime[2] === "3" || newSearchTime[2] === "4") {

        // let newSearchTime = searchingtime.replaceAll(":", "").replaceAll(" ", "");
        // if (newSearchTime[2] === "1" || newSearchTime[2] === "3" || newSearchTime[3] === "4") {
        // let newSting1 = setCharAt(searchingtime, 3, "");
        // let newSting = searchText[3] !== "0" ? setCharAt(newSting1, 3, "") : searchingtime;

        status =
          newSearchTime[0] == searchingtime[0] &&
          newSearchTime[1] == searchingtime[1] &&
          newSearchTime[2] == searchingtime[3]

        // !case1
        // newSting
        //   // .replaceAll(":", "")
        //   .replaceAll(" ", "")
        //   .toLowerCase()
        //   .includes(searchText.toLowerCase());
      }
      else {


        if (case1) {
          status =
            (searchingtime
              .replaceAll(":", "")
              .replaceAll("0", "")
              .replaceAll(" ", "")
              .toLowerCase()
              .includes(searchText.toLowerCase()) &&
              searchText[0] === searchingtime[1]) || (searchingtime
                .replaceAll(" ", "")
                .toLowerCase()
                .includes(searchText.toLowerCase()) &&
                searchText[0] === searchingtime[1]);
        } else if (case2 && !case1) {
          let catchstatus = false;
          if (searchingtime[0] === "1" && searchingtime[1] === "0" && searchText[2] !== ":") {
            let newSting1 = setCharAt(searchingtime, 3, "");

            let newSting = setCharAt(newSting1, 3, "");

            catchstatus =
              searchText[0] === searchingtime[0] &&
              searchText[1] === searchingtime[1] &&
              !case1 &&
              newSting
                .replaceAll(":", "")
                .replaceAll(" ", "")
                .toLowerCase()
                .includes(searchText.toLowerCase());
          }
          else if (searchingtime[0] === "1" && searchingtime[1] === "0" && searchingtime[2] === ":") {

            let newSting1 = setCharAt(searchingtime, 3, "");

            let newSting = searchText[3] !== "0" ? setCharAt(newSting1, 3, "") : searchingtime;

            catchstatus =
              searchText[0] === searchingtime[0] &&
              searchText[1] === searchingtime[1] &&
              !case1 &&
              newSting
                // .replaceAll(":", "")
                .replaceAll(" ", "")
                .toLowerCase()
                .includes(searchText.toLowerCase());
          }
          /////


          /////
          // if (option.data.value[0] === '1' && option.data.value[1] === '0' && (option.data.value === '10:00 AM' || option.data.value === '10:00 PM')) {
          //   catchstatus = searchText[0] === option.data.value[0] && searchText[1] === option.data.value[1] && !case1 &&
          //     option.data.value.replaceAll(':', '').replaceAll(' ', '').toLowerCase().includes(searchText.toLowerCase())
          // }
          else if (searchText[0] === searchingtime[0] &&
            searchText[1] === searchingtime[1] &&
            !case1 && searchText[2] !== ":") {
            catchstatus = catchstatus =
              searchText[0] === searchingtime[0] &&
              searchText[1] === searchingtime[1] &&
              !case1 &&
              searchingtime
                .replaceAll(":", "")
                .replaceAll("0", "")
                .replaceAll(" ", "")
                .toLowerCase()
                .includes(searchText.toLowerCase());
          }
          else {
            catchstatus = catchstatus =
              searchText[0] === searchingtime[0] &&
              searchText[1] === searchingtime[1] &&
              !case1 &&
              searchingtime
                // .replaceAll(":", "")
                // .replaceAll("0", "")
                .replaceAll(" ", "")
                .toLowerCase()
                .includes(searchText.toLowerCase());
          }
          status = catchstatus;
          // status = searchText[0] ===  option.data.value[0]
        }
        // else if(case10){
        //   status = true
        // }
        else {
          status = false;
        }
      }
    }
    // return status;
    let case2 =
      searchingtime
        .replaceAll(":", "")
        .replace("0", "")
        .indexOf(searchText.toLowerCase()) === 0;
    // }

    if (
      status
      // option.data.value.toLowerCase().includes(searchText.toLowerCase()) ||
      //   // option.data.val.toLowerCase().includes(searchText.toLowerCase()) ||
      //  option.data.value.replaceAll(':','').replace('0','').indexOf(searchText.toLowerCase()) === 0
      // `${option.data.value.split(':')[0]}AM`.toLowerCase().includes(searchText.toLowerCase()) ||
      // `${option.data.value.split(':')[0]}PM`.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getNewList = (value) => {
    let newArray = [];
    let filternewList = [];
    newArray = slotsList.filter(
      (option, index) =>
        formatTimeTo24hrs(
          option.value
        ) >
        formatTimeTo24hrs(
          value.value
        )
    )
    filternewList = slotsList.filter(
      (option, index) =>
        formatTimeTo24hrs(
          option.value
        ) <
        formatTimeTo24hrs(
          value.value
        )
    )

    let array = filternewList.reverse();
    let arr = newArray.concat(array);
    setSlotsList(arr);
  }
  const cancelRequest = () => {
    window.loadModal2("#confirmCurrency", "hide");

  };
  const confirmRequest = () => {
    checkOfflineStatus(formBody)
  };

  const checkTimeDifferenceBetweenTime = (values, prevVal, value, dir, day) => {
    let status = true;
    let check = type == "admin" ? values.session_type !== "" : values.session_type.length
    if (check && dir == "to" && day !== 'blockedDateSlots') {
      const timeToMinutes = (time) => {
        let [hours, minutes] = time.split(':');
        minutes = parseInt(minutes.slice(0, 2));
        const period = time.slice(-2);
        hours = parseInt(hours);

        if (period === "PM" && hours !== 12) {
          hours += 12;
        } else if (period === "AM" && hours === 12) {
          hours = 0;
        }

        return hours * 60 + minutes;
      };
      const startlabel = prevVal.label;
      const endlabel = value.label
      let array = []
      if (type == "admin") {
        let filter = sessions.filter((row) => parseInt(row.sub_session_id) == parseInt(values.session_type));
        array = filter
      }
      else {
        array = values.session_type
      }
      const buffer_time = parseInt(values.buffer_time) // in minutes
      array.map((item) => {
        const duration = parseInt(item.duration); // in minutes

        const startMinutes = timeToMinutes(startlabel);

        const endMinutes = timeToMinutes(endlabel);
        const timeDifference = endMinutes - startMinutes;

        const totalTime = duration + buffer_time;

        const isTimeSufficient = timeDifference >= totalTime;

        status = isTimeSufficient;
      })



      // Function to convert time from "HH:MM AM/PM" to minutes


    }
    return status;
  }
  const customChangeHandler
    = (
      index,
      value,
      setFieldValue,
      name,
      values,
      day,
      dir,
      prevVal
    ) => {

      let status = parseInt(values.is_group_session) == 0 ? checkTimeDifferenceBetweenTime(values, prevVal, value, dir, day) : true;
      if (status == true) {


        if (dir === "to" && prevVal !== undefined && checkIsGroupSessionTitles(values, "group", "normal") == "group") {

          let cu = value.value;
          let prev = prevVal.value;
          var startTime = moment(prev, 'HH:mm a');
          var endTime = moment(cu, 'HH:mm a');

          var duration = moment.duration(endTime.diff(startTime));
          var minutes = duration.asMinutes();
          if (minutes > 120) {
            setTimeout(() => {

              window.loadModal('#ConfirmTime', 'show')
            }, 300);
          }
        }
        setFieldValue(name, value);
        // getNewList(value);
        // let currentArrayValue = data

        if (
          (day === "specificDateSlots" || day === "blockedDateSlots") &&
          dir === "to"
        ) {
          // let data = values[day][0].time;

          // let updatedValue = data[index]
          // dir === "from" ? (updatedValue.from = value) : (updatedValue.to = value);
          // let newValues = evaluate(data, setFieldValue, day);

          // let update = [{ date: values[day][0].date, time: newValues }];

          // setFieldValue(day, update);

        }
        if (
          dir === "to" &&
          (day !== "specificDateSlots" && day !== "blockedDateSlots")
        ) {
          let data = values[day];

          let updatedValue = data[index]
          dir === "from" ? (updatedValue.from = value) : (updatedValue.to = value);
          // makeloop(data, updatedValue, setFieldValue, day)
          let newValues = evaluate(data, setFieldValue, day);
          setFieldValue(day, newValues);
          // compareObjects(data, updatedValue, setFieldValue, day);
        }
      }
      else {
        setTimeDifferenceError(true);

        setTimeout(() => {
          setTimeDifferenceError(false);
        }, 3500);
      }
    };

  const onMenuOpen = () => {
    setTimeout(() => {
      // const focusedOptionRef = document.getElementsByClassName("css-9gakcf-option")[0];
      const cala = document.getElementsByClassName("css-4ljt47-MenuList")[0];


      // focusedOptionRef.scrollIntoView({block: "start", inline: "nearest",behavior:});
      // focusedOptionRef.parentNode.scrollTop = focusedOptionRef.offsetTop - focusedOptionRef.parentNode.offsetTop;    to to back
    }, 2000);
  };

  // const scrollMenuToTarget = () => {


  //   setTimeout(() => {

  //     // const { focusedOptionRef } = selectRef.current;
  //   const focusedOptionRef = document.getElementsByClassName("css-yt9ioa-option")[25];

  //     focusedOptionRef &&
  //       focusedOptionRef.scrollIntoView({ behavior: "smooth" });
  //   }
  //   , 1);
  // };

  const scrollMenuToTarget = (dir, day) => {
    if (dir === "from") {
      setTimeout(() => {
        // const cala = document.getElementsByClassName("css-11unzgr")[0]; //to be back
        const cala = document.getElementsByClassName("css-4ljt47-MenuList")[0];
        //  to be back

        // let elemHeight = cala.offsetHeight;


        //  const selectedValue=document.getElementsByClassName("css-1n7v3ny-option");
        //  let valueHeight=selectedValue.offsetHeight;



        // document.querySelector(".output").textContent
        //     = elemHeight + "px";
        // css-4ljt47-MenuList

        // css-11unzgr"
        if (window.innerWidth < 500) {
          if (day !== undefined) {
            cala.scrollTop = 930;
          }
          else {

            cala.scrollTop = 1140;
          }
        } else {
          if (day !== undefined) {
            cala.scrollTop = 1500;
          }
          else {

            cala.scrollTop = 1140;
          }
        }
      }, 200);
    }
    if (dir === "spec_block_date") {
      setTimeout(() => {
        // const cala = document.getElementsByClassName("css-11unzgr")[0]; // to be back
        const cala = document.getElementsByClassName("css-4ljt47-MenuList")[0];
        // to be back
        if (window.innerWidth < 500) {
          if (day !== undefined) {
            cala.scrollTop = 1200;
          }
          else {

            cala.scrollTop = 1140;
          }
        } else {
          if (day !== undefined) {
            cala.scrollTop = 1138;
          }
          else {

            cala.scrollTop = 1140;
          }
        }
      }, 200);
    }
  };
  const makeloop = (mainArray) => {
    const check = (time) => {
      return moment(time, "hh:mm:a").format("X");
    };
    mainArray.forEach((outerValue, index) => {
      let currentFromValue = check(outerValue.from.value);
      let currentToValue = check(outerValue.to.value);
      mainArray.forEach((innerValue, innerIndex) => {
        let loopFromValue = check(innerValue.from.value);
        let loopToValue = check(innerValue.to.value);

        if (
          currentFromValue < loopFromValue &&
          currentToValue < loopFromValue &&
          currentToValue < loopToValue
        ) {
          mainArray[index].from = outerValue.from;
        } else if (
          currentFromValue < loopFromValue &&
          currentToValue > loopToValue
        ) {
          mainArray[index].from = outerValue.from;
          mainArray[index].to = outerValue.to;
        } else if (
          currentFromValue < loopFromValue &&
          currentFromValue < loopToValue &&
          currentToValue < loopFromValue &&
          currentToValue < loopToValue
        ) {
          //Nothing
          console.log("Index TO update", index);
          console.log("case 4");
        } else if (
          currentFromValue < loopFromValue &&
          currentFromValue < loopToValue &&
          currentToValue > loopToValue
        ) {
          mainArray[index].to = outerValue.to;
        } else if (
          currentFromValue > loopFromValue &&
          currentToValue > loopFromValue &&
          currentToValue < loopToValue
        ) {
          //Nothing
          return 0;
        } else if (
          currentFromValue > loopFromValue &&
          currentFromValue < loopToValue &&
          currentToValue > loopToValue
        ) {
          mainArray[index].to = outerValue.to;
        } else if (
          currentFromValue < loopFromValue &&
          currentToValue > loopFromValue &&
          currentToValue < loopToValue
        ) {
          mainArray[index].from = outerValue.from;
        }
      });
    });
  };
  const consolidateArray = (index, childIndex, array, updatedValue, dir) => {
    if (index !== childIndex) {
      array[index][dir] = updatedValue;
    }
  };

  const filterMoment = (time) => {
    return moment(moment(time, ["h:mm A"]).format("HH:mm"), "HH:mm");
  };
  const evaluate = (state, setFieldValue, day) => {
    //filter state

    const filteredState = [];
    for (let i in [...state]) {
      const entry = { ...state[i] };
      const from = moment(entry.from.value, ["h:mm a"]).format("HHmm");
      const to = moment(entry.to.value, ["h:mm a"]).format("HHmm");

      let isExist = false;

      for (let key in state) {
        const s = state[key];

        if (filteredState.length === 0) {
          isExist = false;
          break;
        }

        if (i !== key) {
          const from1 = moment(s.from.value, ["h:mm a"]).format("HHmm");
          const to1 = moment(s.to.value, ["h:mm a"]).format("HHmm");

          if (
            parseInt(from) === parseInt(from1) &&
            parseInt(to) === parseInt(to1)
          ) {
            isExist = true;
            break;
          } else {
            isExist = false;
            continue;
          }
        }
      }
      if (!isExist) {
        filteredState.push(entry);
      }
    }

    let currentValues = [...filteredState];
    let newValues = [...filteredState];

    for (let i in currentValues) {
      const d = currentValues[i];
      for (let ind in newValues) {
        const e = newValues[ind];
        if (i !== ind) {
          if (
            moment(filterMoment(d.from.value)).isBetween(
              filterMoment(e.from.value),
              filterMoment(e.to.value)
            ) &&
            moment(filterMoment(d.to.value)).isBetween(
              filterMoment(e.from.value),
              filterMoment(e.to.value)
            )
          ) {
            newValues[i]["disabled"] = true;
            break;
          }

          // if to date is after
          if (
            (moment(filterMoment(d.from.value)).isBetween(
              filterMoment(e.from.value),
              filterMoment(e.to.value)
            ) ||
              moment(filterMoment(d.from.value)).isSame(
                filterMoment(e.from.value)
              )) &&
            (moment(filterMoment(d.to.value)).isAfter(
              filterMoment(e.to.value)
            ) ||
              moment(filterMoment(d.to.value)).isSame(filterMoment(e.to.value)))
          ) {

            newValues[ind].to = d.to;
            newValues[ind]["disabled"] = false;
            newValues[i]["disabled"] = true;
            break;
          }

          // if from date is smaller
          if (
            (moment(filterMoment(d.to.value)).isBetween(
              filterMoment(e.from.value),
              filterMoment(e.to.value)
            ) ||
              moment(filterMoment(d.to.value)).isSame(
                filterMoment(e.to.value)
              )) &&
            (moment(filterMoment(d.from.value)).isBefore(
              filterMoment(e.from.value)
            ) ||
              moment(filterMoment(d.from.value)).isSame(
                filterMoment(e.from.value)
              ))
          ) {

            newValues[ind].from = d.from;
            newValues[ind]["disabled"] = false;
            newValues[i]["disabled"] = true;
            break;
          }
          if (
            moment(filterMoment(d.to.value)).isSame(filterMoment(e.from.value))
            && d.to.change === 'YES') {
            newValues[i].to = e.to;
            break;
            // d.to.value = e.from.value
            // console.log(d.from.value, "d.from.value")
            // console.log(d.to.value, "d.to.value")
            // console.log(e.to.value, "e.to.calue");
            // console.log(e.from.value, "e.from.valie")
          }
        }
      }
    }

    newValues = newValues.filter((v) => !v.disabled);

    return newValues;
  };
  const onChangeFulldayHandler = (e, type, values, setFieldValue) => {
    let checked = e.target.checked;
    if (type === "blocked") {
      setBlockedFullday(!blockedfullday)
    }
    if (type === "specific") {
      setspecificFullday(!specificfullday)
    }
    let first = slotsList[0];
    let last = slotsList[slotsList.length - 1];
    if (type === "specific") {
      let value = values.specificDateSlots[0];
      if (!specificfullday) {
        let time = value.time[0];
        time.from = first;
        time.to = last;
      } else {
        let value = values.specificDateSlots[0];
        let time = value.time[0];
        time.from = "";
        time.to = "";
      }
      setFieldValue("specificDateSlots", [value]);
    } else if (type === "blocked") {
      let value = values.blockedDateSlots[0];
      if (!blockedfullday) {
        let time = value.time[0];
        time.from = first;
        time.to = last;
      } else {
        let value = values.blockedDateSlots[0];
        let time = value.time[0];
        time.from = "";
        time.to = "";
      }
      setFieldValue("blockedDateSlots", [value]);
    }
  };
  const onCustomdateChangeHandler = (e, type, name, setFieldValue) => {
    if (type === 'specific') {
      let check = testValues.some((data => data.date === e.target.value))
      if (!check) { setFieldValue(name, e.target.value) } else {
        toast.error(t("toasts.dateAlreadyExist"), { position: "top-center" });
      }
    }
    if (type === 'blocked') {
      let check = blockedDatesValues.some((data => data.date === e.target.value))
      if (!check) { setFieldValue(name, e.target.value) } else {
        toast.error(t("toasts.dateAlreadyExist"), { position: "top-center" });
      }
    }
  }


  const unitChangeHandler = (e, setFieldValue) => {
    let value = e.target.value
    setUnitValue(e.target.value);
    setTimeout(() => {


      if (value === "Days") {
        setFieldValue('min_booking_days', '01');
        setFieldValue('min_booking_hour', '');
        setFieldValue('min_booking_time', '');
      }
      if (value === "Hours") {
        setFieldValue('min_booking_days', '');
        setFieldValue('min_booking_hour', '01');
        setFieldValue('min_booking_time', '');
      }
      if (value === "Minutes") {
        setFieldValue('min_booking_days', '');
        setFieldValue('min_booking_hour', '');
        setFieldValue('min_booking_time', '15');
      }

    }, 100)
  }
  const checkUnitType = (value) => {
    if (value.min_booking_days !== "00" && value.min_booking_days !== "") {
      setUnitValue('Days')
    }
    if (value.min_booking_time !== "00" && value.min_booking_time !== "") {
      setUnitValue('Minutes')
    }
    if (value.min_booking_hour !== "00" && value.min_booking_hour !== "") {
      setUnitValue('Hours')
    }
  }
  const checkOfflineStatus = (body) => {

    let session = body.session_type[0];
    if (session.sub_session_id === 78) {
      window.loadModal('#ConfirmOffline', 'show');
      setTemporaryStorage(body)
    }
    else {


      // if (body.session_type.length === 1) {
      //   localStorage.setItem('showpreviewValue', body.session_type[0].sub_session_id)
      //   setTemporaryStorage(body)
      //   window.loadModal2('#PreviewCheckbox', 'show');
      // }
      // else {
      submitForm(body)
      // }


    }

    // submitForm(body);
  }
  const confirmFormRequest = () => {
    submitForm(temporaryStorage)
  }
  const closePopup = () => {
    window.loadModal('#ConfirmOffline', 'hide');
  }

  const checkTypeOfMedium = (e, setFieldValue, values) => {

    // { id: 1, name: "Novice I" },
    // { id: 2, name: "Intermediate I" },
    // { id: 3, name: "Professional I" },
    // { id: 4, name: "Novice II" },
    // { id: 5, name: "Intermediate II" },
    // { id: 6, name: " Professional II" },
    // { id: 7, name: "Professional III" },
    let value = []

    // setFieldValue('preferred_medium_level', [])
    // value.push(level.toString())

    values.preferred_medium_level = value
    // console.log(newInfo)
    // console.log(initialValues,"initialValues")
    // if (level === 1 || level === 4) {
    //   initialValues.preferred_medium_level = ["1"]
    //   value = ["1",]
    // }
    // else if (level === 2 || level === 5) {
    //   initialValues.preferred_medium_level = ["2"]
    //   value = ["2",]

    // }
    // else if (level === 3 || level === 6 || level === 7) {
    //   initialValues.preferred_medium_level = ["3"]
    //   value = ["3"]


    // }
    // if (window.valueupdated) {
    //   window.valueupdated = false;
    // setValueUpdated(false);

    setFieldValue('preferred_medium_level', value)

    // }
    // setValues(initialValues);

  }
  const checkPreferedType = (type, values, setFieldValue, setshowpreffered) => {
    // console.log(num === 3 && (level === 3 || level === 6 || level === 7), num, "num")
    let status = true;

    if (type === "admin") {
      let filtered = sessions.filter((item) => item.sub_session_id == values.session_type)
      if (filtered.length > 0 && filtered[0].is_group_session == 1) {
        // checkTypeOfMedium(setFieldValue)

        status = false
        // setshowpreffered(true);

      }
      else if (filtered[0].is_medium_level == 1) {
        status = false
        // setshowpreffered(true);

      }
      else {
        status = true
        // setshowpreffered(false);
      }
    }
    else {

      if (typeof values.session_type === "object" && values.session_type.length > 0) {
        let info = values.session_type.filter((item) => parseInt(item.is_group_session) === 1)
        let info1 = values.session_type.filter((item) => parseInt(item.is_medium_level) == 1)
        if (info.length > 0) {
          // checkTypeOfMedium(setFieldValue)

          status = false
          // setshowpreffered(true);

        }
        else if (info1.length > 0) {
          status = false
          // setshowpreffered(true);
        }
        else {
          status = true
          // setshowpreffered(false);
        }
      }
    }
    // type === "admin" ? values.session_type !== "64" : values.session_type == "" ? true : values.session_type.length > 0 && values.session_type.filter((item) => item.value === 64)[0].value !== 64)

    return status;

  }

  const checkPreferedMediums = (values) => {


    // let newItem = items.filter((item) => { if (item.checked === true) return { ...item.value } })
    // let newArray = newItem.map((item) => item.value)

    let partner = values.preferred_medium_level;
    if (partner.includes("1")) {
      if (!partner.includes("4")) {
        partner.push("4")
      }
    }
    else {
      let index = partner.indexOf('4');
      if (index !== -1) {
        partner.splice(index, 1);
      }
    }
    if (partner.includes("2")) {
      if (!partner.includes("5")) {
        partner.push("5")

      }
    }
    else {
      let index = partner.indexOf('5');
      if (index !== -1) {
        partner.splice(index, 1);
      }
    }
    if (partner.includes("3")) {
      if (!partner.includes("6")) {
        partner.push("6")
      }
      if (!partner.includes("7")) {
        partner.push("7")
      }

    }
    else {
      let index1 = partner.indexOf('6');
      let index2 = partner.indexOf('7');
      if (index1 !== -1) {
        partner.splice(index1, 1);
      }
      if (index2 !== -1) {
        partner.splice(index2, 1);
      }
    }
    return partner;
  }

  const changeHna = (e, setFieldValue) => {
    let value = e.target.value;
    let newVal = value.replace(/\D+/g, '')
    if (newVal < 0 || newVal > 1000) {
      return;
    }
    else {
      setFieldValue('max_attendees', newVal);
      // setUpMarkupValu(newVal);
    }
  }
  const changeHnadclient = (e, setFieldValue) => {
    let value = e.target.value;
    let newVal = value.replace(/\D+/g, '')
    if (newVal < 0 || newVal > 21) {
      return;
    }
    else {
      setFieldValue('client_attendees', newVal);
      // setUpMarkupValu(newVal);
    }
  }
  const changeHnadMedium = (e, setFieldValue) => {
    let value = e.target.value;
    let newVal = value.replace(/\D+/g, '')
    if (newVal < 0 || newVal > 21) {
      return;
    }
    else {
      setFieldValue('max_mediums', newVal);
      // setUpMarkupValu(newVal);
    }
  }
  const changePriceForattendees = (e, setFieldValue) => {
    let value = e.target.value;
    let newVal = value.replace(/\D+/g, '')
    setFieldValue('price_for_attendees', newVal);
  }
  const checkIsGroupSessionTitles = (values, groupTitle, OtherTitle) => {
    if (type !== "admin") {
      if (values.session_type.length > 0 && values.session_type.some((item) => parseInt(item.is_group_session) === 1)) {
        return groupTitle
      }
      else {
        return OtherTitle
      }
    }
    else {
      let items = sessions.length && sessions.filter((item) => parseInt(item.sub_session_id) === parseInt(values.session_type))
      if (items.length && items[0].is_group_session === 1) {
        return groupTitle
      }
      else {
        return OtherTitle
      }
    }


  }

  const closePreviewCheckbox = () => {
    window.loadModal2('#PreviewCheckbox', 'hide');
    submitForm(temporaryStorage)

  }

  const openPreviewCheckbox = () => {
    localStorage.setItem('showpreview', 'showpreview')
    submitForm(temporaryStorage)

  }
  const onYesClick = () =>{

    const key = "availabilityNoteClosedAt";

    // 1. Get existing data (or empty object if nothing stored yet)
    let storedData = JSON.parse(localStorage.getItem(key)) || {};

    // 2. Update the timestamp for this userId
    storedData[userId] = moment().toISOString();

    // 3. Save back to localStorage
    localStorage.setItem(key, JSON.stringify(storedData));
      checkOfflineStatus(formBody);
    }
    const onNoClick = () =>{
    localStorage.setItem("availabilityNoteClosedAt", moment().toISOString());
   }

  //description



  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [contentState, setContentState] = useState(null);

  const handleContentStateChange = (contentState) => {
    setContentState(draftToHtml(contentState));
  };
  const submitFormData = () => {

  const key = "availabilityNoteClosedAt";
  const storedData = JSON.parse(localStorage.getItem(key)) || {};
  const lastClosedDate = storedData[userId];

  if (!lastClosedDate) {
    showModal();
  } else {
      const closedAt = moment(lastClosedDate);
  const nextShowDate = closedAt.clone().add(7, "days");
  const now = moment();

  if (now.isSameOrAfter(nextShowDate)) {
      showModal();
    }else{
      checkOfflineStatus(formBody);
    }
  }

  function showModal() {

      window.jQuery('#AvailabilityNotePopup').modal({
        show: true
      });
  }
  }

  const hasSubSession83 =
  values &&
  (
    // case 1: session_type is directly 83
    values.session_type == process.env.REACT_APP_COACHING_GROUP_SESSION_ID ||

    // case 2: session_type is an array with objects
    (Array.isArray(values.session_type) &&
      values.session_type.some(item => item.sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID))
  );

  const hasSelectedSubSession = (sessionType, subSessionId) =>
    sessionType == subSessionId ||
    (Array.isArray(sessionType) &&
      sessionType.some(
        (item) => item.value == subSessionId || item.sub_session_id == subSessionId
      ));

  const isSession93 =
    values &&
    hasSelectedSubSession(values.session_type, 93);

  const isSession101 =
    values &&
    hasSelectedSubSession(values.session_type, 101);

  return !isValueLoded ? (

    <div className="d-flex align-items-center justify-content-center h-100">
      {t("loading")}
    </div>
  ) : (
    <>
      {timeDifferenceError && <div className="time-difference-popup">
        {t("timeDifferenceError")}
      </div>}
      <div className="add-availability-window-box margin-botton-200px margin-botton-50px">
        <div className="hadding-window">
          <span onClick={cancelForm} className="pointer">
            <span>
              <img src="images/arrow-back.png" />
              {t("backToSchedules")}
            </span>
          </span>
        </div>
        {auth.role === "medium" && <div className="middle-screen-name time-zone-area font-size-22 mt-2 mb-2">
          {" "}
          <select
            onChange={changeTimeZoneHandler}
            className="select-box-timezone pointer"
          >
            <option disabled selected value="">
              {t("timezone.change")}
            </option>
            {timezoneData.map((item) => (
              <option value={item.id}>
                {item.front_name}
              </option>
            ))}
          </select>
          <b>{t("timezone.label", { timezone: timezone !== undefined ? timezone : "" })}&nbsp;</b>
        </div>}
        {auth.role === "admin" && <div className="middle-screen-name time-zone-area font-size-22 mt-2 mb-2">
          {" "}

          <b>{t("timezone.mediumLabel", { timezone: screenNameDetails !== null ? screenNameDetails.time_zone : "" })}&nbsp;</b>
        </div>}
        <Formik
          initialValues={values}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          validate={(values) => {
            
            const errors = {};
            if (values.session_type.length <= 0)
              errors.session_type = t("common:validation.required");
            if (!values.start_date) errors.start_date = t("common:validation.required");
            if (values.country_type === "All Countries with Exclusions" && values.exclusions.length <= 0) errors.exclusions = t("common:validation.required");
            if (values.country_type === "Selected Countries only" && values.inclusions.length <= 0) errors.inclusions = t("common:validation.required");
            if (type !== "admin" && values.session_type.filter((item) => { return item.session_type === 1 }).length > 0) {
              if (!values.preferred_medium_level.length) {
                errors.preferred_medium_level = t("common:validation.required")
              }
            }
            if(showGroupSession && !values.max_attendees && !clientMediumAttendees){
              window.$('#collapse-1').collapse('show');
              errors.max_attendees = t("common:validation.required");
            }
            // let filtered = sessions.filter((item) => item.sub_session_id == value)
            if (type == "admin" && values.session_type == "95") {
              if (!values.title) errors.title = t("common:validation.required");
              if (!values.sub_title) errors.sub_title = t("common:validation.required");
              // if (!values.description) errors.description = "Required";

            }
            let isSession101 = false;

              // Medium login (direct value)
              if (values && values.session_type == 101) {
                isSession101 = true;
              }

              // Admin login (array)
              if (!isSession101 && Array.isArray(values.session_type)) {
                isSession101 = values.session_type.some(
                  item => item.value == 101 || item.sub_session_id == 101
                );
              }
            if ( isSession101) {
              console.log(values.description, "description")
              if (!values.title) errors.title = t("common:validation.required");
              if (!values.sub_title) errors.sub_title = t("common:validation.required");
              var descText = "";
              const rawHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
              function isEditorEmpty(rawHtml) {
  if (!rawHtml) return true;

  var text = rawHtml
    .replace(/<[^>]*>/g, "")   // remove tags
    .replace(/&nbsp;/g, "")    // remove &nbsp;
    .replace(/\s+/g, "")       // remove spaces
    .trim();

  return text === "";
}

  if (isEditorEmpty(rawHtml)) {
    errors.description = t("common:validation.required");
  }

            }
            console.log(values.session_type, "values.session_type", values)
            
            let isSession93 = false;

            // Admin login (direct value)
            if (values && values.session_type == 93) {
              isSession93 = true;
            }

            // Medium login (array)
            if (!isSession93 && Array.isArray(values.session_type)) {
              isSession93 = values.session_type.some(
                item => item.value == 93 || item.sub_session_id == 93
              );
            }

            if (topicShow && !values.topic) {
  errors.topic = t("common:validation.required");
}
            setErrorMessages(errors)
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {

            const rawHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
            // let preferred_medium = checkPreferedMediums(values).sort();
            

            // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            let getSessionType = sessions.filter((item) => {
              if (schedule_id === "" ?
                parseInt(item.sub_session_id) === parseInt(values.session_type) :
                parseInt(item.sub_session_id) === parseInt(values.session_type)
              ) {
                return {
                  session_type: item.session_type,
                  sub_session_id: item.sub_session_id,
                };
              }
            });
            let countryType = getCountryTypes(
              values.country_type,
              values.exclusions,
              values.inclusions
            );
            let flag_hours =
              parseInt(
                values.min_booking_hour !== "" ? values.min_booking_hour : 0
              ) +
              parseInt(
                parseInt(
                  values.min_booking_days !== "" ? values.min_booking_days : 0
                ) * 24
              );

            let flag_hoursmax = parseInt(
              parseInt(
                values.max_booking_days !== "" ? values.max_booking_days : 0
              ) * 24
            );
            let getdATA =
              values.min_booking_time !== ""
                ? `${flag_hours}.${values.min_booking_time}`
                : flag_hours;
            let getdATAMax =
              values.max_booking_days !== "" &&
                values.max_booking_days !== null &&
                values.max_booking_days !== NaN
                ? parseInt(values.max_booking_days) * 24
                : 1440;

            let body = {
              ...values,
              preferred_medium_level: JSON.stringify(values.preferred_medium_level),
              topic: values.topic,
              medium_availability_id: isCopyType == 0 ? mediumAvailabilityId : "",
              //
              //
              //


              session_type:
                type === "admin" ? getSessionType : values.session_type,
              meeting_preferences:
                values.meeting_preferences_meeting.length > 0 &&
                values.meeting_preferences_meeting.map((item) => {
                  return item.value;
                }),

              recording: values.recording,
              min_book_time: getdATA,
              max_book_time: getdATAMax,
              medium_id: medium_id,
              participant_preferences: countryType,
              specificDateSlotsdata:
                testValues.length &&
                  testValues[0].date !== "" &&
                  testValues[0].time.length > 0
                  ? JSON.stringify(
                    testValues.map((item) => {
                      return { date: item.date, time: handleTime1(item.time) };
                    })
                  )
                  : JSON.stringify([]),

              blockedSpecificSlotsData:
                blockedDatesValues.length &&
                  blockedDatesValues[0].date !== "" &&
                  blockedDatesValues[0].time.length > 0
                  ? JSON.stringify(
                    blockedDatesValues.map((item) => {
                      return { date: item.date, time: handleTime1(item.time) };
                    })
                  )
                  : JSON.stringify([]),
              schedule: JSON.stringify({
                sunday: handleTime(values.scheduleSunday),
                monday: handleTime(values.scheduleMonday),
                tuesday: handleTime(values.scheduleTuesday),
                wednesday: handleTime(values.scheduleWednesday),
                thursday: handleTime(values.scheduleThursday),
                friday: handleTime(values.scheduleFriday),
                saturday: handleTime(values.scheduleSaturday),
              }),
              receive_email: values.receive_email ? 1 : 0,
              cancellation_email: values.cancellation_email ? 1 : 0

            };
          let isSession101 = false;

              // Medium login (direct value)
              if (values && values.session_type == 101) {
                isSession101 = true;
              }

              // Admin login (array)
              if (!isSession101 && Array.isArray(values.session_type)) {
                isSession101 = values.session_type.some(
                  item => item.value == 101 || item.sub_session_id == 101
                );
              }

          let isSession93 = false;

              // Medium login (direct value)
              if (values && values.session_type == 93) {
                isSession93 = true;
              }

              // Admin login (array)
              if (!isSession93 && Array.isArray(values.session_type)) {
                isSession93 = values.session_type.some(
                  item => item.value == 93 || item.sub_session_id == 93
                );
              }

          let isSession94 = false;
              if (values && values.session_type == 94) {
                isSession94 = true;
              }
              if (!isSession94 && Array.isArray(values.session_type)) {
                isSession94 = values.session_type.some(
                  item => item.value == 94 || item.sub_session_id == 94
                );
              }

          let isSession83 = false;
              if (values && values.session_type == process.env.REACT_APP_COACHING_GROUP_SESSION_ID) {
                isSession83 = true;
              }
              if (!isSession83 && Array.isArray(values.session_type)) {
                isSession83 = values.session_type.some(
                  item => item.value == process.env.REACT_APP_COACHING_GROUP_SESSION_ID || item.sub_session_id == process.env.REACT_APP_COACHING_GROUP_SESSION_ID
                );
              }

            if (values.session_type == "95" || isSession101 || isSession93) {

              let meta = {
                meta_data: {
                  title: values.title,
                  sub_title: values.sub_title,
                  // description: values.description,
                  description: JSON.stringify({ content: rawHtml }),
                }
              }

              Object.assign(body, meta)
            } else if (isSession94 || isSession83) {

              let meta = {
                meta_data: {
                  title: values.title,
                  sub_title: values.sub_title,
                }
              }

              Object.assign(body, meta)
            }
            if (values.session_type == "33") {
              let additional_worker_data = {
                additional_worker: values.additional_worker,
              }

              Object.assign(body, additional_worker_data)
            }

            if (userCurrency !== values.session_currency) {
              window.loadModal2("#confirmCurrency", "show");
              setFormBody(body)
            } else {
              setFormBody(body)
               if(auth.role != "medium"){

                   checkOfflineStatus(body)
              }else{
                  // const key = "availabilityNoteClosedAt";
                  // const storedData = JSON.parse(localStorage.getItem(key)) || {};
                  // const lastClosedDate = storedData[userId];
                  const key = "availabilityNoteClosedAt";
                  let raw = localStorage.getItem(key);
                  let storedData = {};

                  if (raw) {
                    try {
                      storedData = JSON.parse(raw);
                      // If somehow it's still a string after parsing, convert it
                      if (typeof storedData === "string") {
                        storedData = { [userId]: storedData };
                        localStorage.setItem(key, JSON.stringify(storedData));
                      }
                    } catch {
                      // Old plain string format → convert to object format
                      storedData = { [userId]: raw };
                      localStorage.setItem(key, JSON.stringify(storedData));
                    }
                  }

                  const lastClosedDate = storedData[userId];

                  if (!lastClosedDate) {
                    submitFormData();
                  } else {
                     const closedAt = moment(lastClosedDate);
                  const nextShowDate = closedAt.clone().add(7, "days"); // date when modal should show again
                  const now = moment();

                  if (now.isSameOrAfter(nextShowDate)) {
                     submitFormData();
                    }else{
                      checkOfflineStatus(body)
                    }
                  }

              }


            }
            // checkOfflineStatus(body)






            // return;
            // checkOfflineStatus(body)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>


              <div className="chosse-name-selectde">
                <label>
                  {t("session.chooseName")} <i>*</i>
                </label>
                <div class="select-dropdown">
                  {type === "admin" ? (
                    <div>
                      <select
                        name="session_type"
                        onChange={(e) => changeHandler(e, setFieldValue, values)}
                        id="session_type"
                        // disabled={schedule_id === "" ?false:true}
                        defaultValue={
                          values.session_type !== ""
                            ? values.session_type
                            : setFieldValue(
                              "session_type",
                              sessions.filter(
                                (option) =>
                                  option.sub_session_name === "Offline"
                              )[0].sub_session_id
                            )
                        }
                        value={values.session_type}
                        className={`${errors.session_type &&
                          touched.session_type &&
                          errors.session_type
                          ? "error-boundry"
                          : ""
                          }`}
                      >
                        <option selected disabled value="">
                          {t("session.typePlaceholder")}
                        </option>

                        {sessions.map((item) => (
                          <option value={item.sub_session_id}>
                            {item.sub_session_name}
                          </option>
                        ))}
                      </select>
                      <span className="error">
                        {errors.session_type &&
                          touched.session_type &&
                          errors.session_type
                          ? t("session.chooseNameError")
                          : ""}
                      </span>

                    </div>
                  ) : (
                    <>
                      <div>
                        <Select
                          id="session_type"
                          // className="assign-level-select"
                          // isDisabled={schedule_id === "" ?false:true}
                          options={sessions}
                          isMulti
                          onChange={(value) =>
                            changeSigleSession(value, setFieldValue, values)
                          }
                          placeholder={t("session.addServicesPlaceholder")}
                          value={values.session_type

                          }

                          closeMenuOnSelect={true}
                          closeMenuOnScroll={false}
                          className={`${errors.session_type &&
                            touched.session_type &&
                            errors.session_type
                            ? "error-boundry"
                            : ""
                            }`}
                        />
                        <span className="error">
                          {errors.session_type &&
                            touched.session_type &&
                            errors.session_type
                            ? t("session.chooseNameError")
                            : ""}
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div className="red font-size-14 mt-2">{alreadyExist && t("session.alreadyExist", { service: alreadyExistService })}</div>
                {active60minNote && <div className="red font-size-14 mt-2">  <i>*</i>&nbsp;{t("session.zoomNote1")}
                  <br />
                  &nbsp; {t("session.zoomNote2")}</div>}
              </div>

              {/***************Event Name */}
              {topicShow &&
                <div className="chosse-name-selectde">
                  <label>
                    {t("session.chooseTopic")} <i>*</i>
                  </label>
                  <div class="select-dropdown">
                    <select
                      name="topic"
                      onChange={handleChange}
                      onBlur={handleBlur}

                      id="topic"
                      // disabled={schedule_id === "" ?false:true}

                      value={values.topic}
                      className={`${errors.topic &&
                        touched.topic &&
                        errors.topic
                        ? "error-boundry"
                        : ""
                        }`}
                    >
                      <option selected disabled value="">
                        {t("session.typePlaceholder")}
                      </option>

                      {newTopic.map((item) => (
                        <option value={item.id}>
                          {item.topic}
                        </option>
                      ))}
                    </select>
                  </div>
                  {errors.topic && touched.topic && (
      <div className="error-text">{errors.topic}</div>
    )}
                </div>
              }
              {evnetInfo && <div className="calendar-box-new">
                <div id="accordion">
                  <div class="card">
                    <div class="card-header" id={"heading-5"}>
                      <h5 class="mb-0">
                        <a
                          class="collapsed"
                          role="button"
                          data-toggle="collapse"
                          href={"#collapse-5"}
                          aria-expanded="false"
                          aria-controls={"collapse-5"}
                        >
                          {""}
                          {t("eventInfo.title")}{" "}   <span className="error inline-block ml-2 mt-1">{errors.title || errors.sub_title || errors.description}</span>
                        </a>
                      </h5>

                      {/* <div className="scheduling-preferences-saction">
                  <h3>Scheduling Preferences</h3> */}
                      <div
                        id={"collapse-5"}
                        class="collapse"
                        data-parent="#accordion"
                        aria-labelledby={"heading-5"}
                      >
                        <div class="card-body">
                          <div className="chosse-name-selectde d-flex ">
                            <div className="w-50">
                              <label>
                                {t("eventInfo.eventName")}{!isSession93 && !hasSelectedSubSession(values.session_type, 94) && !hasSelectedSubSession(values.session_type, process.env.REACT_APP_COACHING_GROUP_SESSION_ID) && <i>*</i>}  <span className="error inline-block ml-2 mt-1">
                                  {errors.title &&
                                    touched.title &&
                                    errors.title
                                  }
                                </span>
                              </label>
                              <div class="select-dropdown">

                                <div>
                                  <input type="text" className="w-100 mt-3 pl-2"
                                    value={values.title}
                                    name="title"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  {/* <span className="error mt-1">
                                    {errors.title &&
                                      touched.title &&
                                      errors.title
                                    }
                                  </span> */}


                                </div>

                              </div>
                            </div>
                            <div className="w-50 ml-5">
                              <label>
                                {t("eventInfo.subText")}{values.session_type == 101 && <i>*</i>}  <span className="error inline-block ml-2 mt-1">
                                  {errors.sub_title &&
                                    touched.sub_title &&
                                    errors.sub_title
                                  }
                                </span>
                              </label>
                              <div class="select-dropdown">

                                <div>
                                  <input type="text" className="w-100 mt-3  pl-2"
                                    value={values.sub_title}
                                    name="sub_title"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  {/* <span className="error mt-1">
                                    {errors.sub_title &&
                                      touched.sub_title &&
                                      errors.sub_title
                                    }
                                  </span> */}
                                  {/* <select
                        name="session_type"
                        onChange={(e) => changeHandler(e, setFieldValue, values)}
                        id="session_type"

                        defaultValue={
                          values.session_type !== ""
                            ? values.session_type
                            : setFieldValue(
                              "session_type",
                              sessions.filter(
                                (option) =>
                                  option.sub_session_name === "Offline"
                              )[0].sub_session_id
                            )
                        }
                        value={values.session_type}
                        className={`${errors.session_type &&
                          touched.session_type &&
                          errors.session_type
                          ? "error-boundry"
                          : ""
                          }`}
                      >
                        <option selected disabled value="">
                          session type
                        </option>

                        {sessions.map((item) => (
                          <option value={item.sub_session_id}>
                            {item.sub_session_name}
                          </option>
                        ))}
                      </select>
                      <span className="error">
                        {errors.session_type &&
                          touched.session_type &&
                          errors.session_type
                          ? "Please Choose Session Name"
                          : ""}
                      </span> */}

                                </div>

                              </div>
                            </div>
                          </div>


                          {!hasSelectedSubSession(values.session_type, 93) && !hasSelectedSubSession(values.session_type, 94) && !hasSelectedSubSession(values.session_type, process.env.REACT_APP_COACHING_GROUP_SESSION_ID) && <div className="chosse-name-selectde d-flex ">

                            <div className="w-100">
                              <label>
                                {t("eventInfo.addDescription")} {isSession101 && <i>*</i>} <span className="error inline-block ml-2 mt-1">
                                  {errors.description &&
                                    touched.description &&
                                    errors.description
                                  }
                                </span>
                              </label>
                              <div class="select-dropdown">

                                <div className="biographical_info_wrapper descriotion-editor-wrapper des-info-ed">

                                  {/* <textarea type="text" className="w-100 mt-3 p-2" rows={20} cols={40}
                                    value={values.description}
                                    name="description"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  /> */}
                                  <Editor
                                    // initialContentState={JSON.parse(values.biographicalInfo)}
                                    placeholder={t("eventInfo.writeHere")}
                                    editorState={editorState}
                                    toolbarClassName="editor-toolbar"
                                    wrapperClassName="editor-wrapper"
                                    editorClassName="editor"
                                    // onEditorStateChange={(editorState) => handleEditorStateChange(editorState, setFieldValue, 'biographicalInfo')}
                                    onEditorStateChange={setEditorState}
                                    onContentStateChange={handleContentStateChange}
                                    toolbar={toolbar}
                                    // localization={localization}
                                    spellCheck
                                  // stripPastedStyles
                                  // toolbarCustomButtons={[<CustomComponent />]}
                                  />

                                </div>

                              </div>
                            </div>
                          </div>}



                          {/*********** */}


                          {/* } */}
                          {/*********** */}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
              {/****************** */}

              {showGroupNotification && (
                <div className="calendar-box-new">
                  <div id="accordion">
                    <div class="card">
                      <div class="card-header" id={"heading-0"}>
                        <h5 class="mb-0">
                          <a
                            class="collapsed"
                            role="button"
                            data-toggle="collapse"
                            href={"#collapse-0"}
                            aria-expanded="false"
                            aria-controls={"collapse-0"}
                          >
                            {""}
                            {t("notifications.title")}{" "}
                          </a>
                        </h5>
                        {/* <div className="scheduling-preferences-saction">
                <h3>Scheduling Preferences</h3> */}
                        <div
                          id={"collapse-0"}
                          class="collapse"
                          data-parent="#accordion"
                          aria-labelledby={"heading-0"}
                        >
                          <div class="card-body pt-4">
                            <div class="form-group d-flex align-items-center">
                              <input
                                onChange={handleChange}
                                type="checkbox"
                                // value={1}
                                name="receive_email"
                                id="receive_email"
                                className="notofication-setting-box"
                                checked={values.receive_email}
                              />
                              <label
                                className="mr-3 margin-unset"
                                for="receive_email"
                              >
                                {t("notifications.receiveEmail")}
                              </label>
                            </div>
                            <div class="form-group d-flex align-items-center">
                              <input
                                onChange={handleChange}
                                type="checkbox"
                                value={"cancellation_email"}
                                name="cancellation_email"
                                id="cancellation_email"
                                className="notofication-setting-box"
                                checked={values.cancellation_email}
                              />
                              <label
                                className="mr-3 margin-unset"
                                for="cancellation_email"
                              >
                                {t("notifications.cancellationEmail")}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              )}


              {/***************** */}

              {/****************** */}

              {/* {showGroupNotification && (
                <div className="calendar-box-new">
                  <div id="accordion">
                    <div class="card">
                      <div class="card-header" id={"heading-90"}>
                        <h5 class="mb-0">
                          <a
                            class="collapsed"
                            role="button"
                            data-toggle="collapse"
                            href={"#collapse-90"}
                            aria-expanded="false"
                            aria-controls={"collapse-90"}
                          >
                            {""}
                            {"Session Hold Options"}{" "}
                          </a>
                        </h5>

                        <div
                          id={"collapse-90"}
                          class="collapse"
                          data-parent="#accordion"
                          aria-labelledby={"heading-90"}
                        >
                          <div class="card-body pt-4">
                            <div class="form-group d-flex align-items-center">
                              <input

                                type="radio"
                                value={1}
                                name="holdoptions"
                                id="receive_email"
                                className="notofication-setting-box"
                                // checked={values.receive_email}
                              />
                              <label
                                className="mr-3 margin-unset"
                                for="receive_email"
                              >
                               Hold time only after booking
                              </label>
                            </div>
                            <div class="form-group d-flex align-items-center">
                              <input
                                // onChange={handleChange}
                                type="radio"
                                value={2}
                                name="holdoptions"
                                id="cancellation_email"
                                className="notofication-setting-box"
                                // checked={values.cancellation_email}
                              />
                              <label
                                className="mr-3 margin-unset"
                                for="cancellation_email"
                              >
                               Block time immediately (no other bookings)
                              </label>
                            </div>
                            <div class="form-group d-flex align-items-center">
                              <input
                                // onChange={handleChange}
                                type="radio"
                                value={3}
                                name="holdoptions"
                                id="cancellation_email"
                                className="notofication-setting-box"
                                // checked={values.cancellation_email}
                              />
                              <label
                                className="mr-3 margin-unset"
                                for="cancellation_email"
                              >
                               Block time immediately (allow other bookings until confirmed)
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              )} */}


              {/***************** */}
              {/***************Appointment setting start */}
              <div className="calendar-box-new">
                <div id="accordion">
                  <div class="card">
                    <div class="card-header" id={"heading-1"}>
                      <h5 class="mb-0">
                        <a
                          class="collapsed"
                          role="button"
                          data-toggle="collapse"
                          href={"#collapse-1"}
                          aria-expanded="false"
                          aria-controls={"collapse-1"}
                        >
                          {""}
                          {t("appointment.title")}{" "}
                        </a>
                      </h5>

                      {/* <div className="scheduling-preferences-saction">
                <h3>Scheduling Preferences</h3> */}
                      <div
                        id={"collapse-1"}
                        class="collapse"
                        data-parent="#accordion"
                        aria-labelledby={"heading-1"}
                      >
                        <div class="card-body">
                          <div className="scheduling-preferencesfilde">
                            {/* {!showGroupSession && */}
                            <div className="preferencesfilde-left">
                              {" "}
                              <span className="strclint golden-icon min-booking-tooltip tooltip-1-focus ">{t("appointment.bufferTime")}</span>
                              <div className="tooltip-1 buffer-tooltip-1">
                                {t("appointment.bufferTooltip")}
                              </div>
                              <div class="select-dropdown">

                                <select
                                  value={values.buffer_time}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name={`buffer_time`}
                                >
                                  <option disabled selected value="">
                                    {t("appointment.bufferTimePlaceholder")}
                                  </option>
                                  <option value={0}>{t("appointment.minutesOption", { count: 0 })}</option>
                                  <option value={15}>{t("appointment.minutesOption", { count: 15 })}</option>
                                  <option value={30}>{t("appointment.minutesOption", { count: 30 })}</option>
                                  <option value={45}>{t("appointment.minutesOption", { count: 45 })}</option>
                                  <option value={60}>{t("appointment.minutesOption", { count: 60 })}</option>
                                  <option value={75}>{t("appointment.minutesOption", { count: 75 })}</option>
                                  <option value={90}>{t("appointment.minutesOption", { count: 90 })}</option>
                                </select>
                              </div>
                            </div>
                            {/* } */}
                            {showNoOfSesionPerDay && <div className={!showNoOfSesionPerDay ? "preferencesfilde-left" : "preferencesfilde-right"}>
                              {" "}
                              <span>{t("appointment.sessionsPerDay")}</span>
                              <div class="select-dropdown">
                                <select
                                  value={values.number_of_session_per_day}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name={`number_of_session_per_day`}
                                  defaultValue={1}
                                >
                                  <option disabled selected value="">
                                    {t("appointment.sessionsPlaceholder")}
                                  </option>
                                  <option value={100}>{t("appointment.unlimited")}</option>
                                  <option value={1}>1</option>
                                  <option value={2}>2</option>
                                  <option value={3}>3</option>
                                  <option value={4}>4</option>
                                  <option value={5}>5</option>
                                  <option value={6}>6</option>
                                  <option value={7}>7</option>
                                  <option value={8}>8</option>
                                  <option value={9}>9</option>
                                  <option value={10}>10</option>
                                </select>
                              </div>
                            </div>}

                            {/*************** */}
                            <div className="scheduling-preferencesfilde">
                            {showGroupSession && (
                              <>
                                <div className="preferencesfilde-left">
                                  {" "}
                                  <span>{t("appointment.numberOfAttendees")}</span>
                                  <div class="select-dropdown">
                                    {!clientMediumAttendees && (
                                    <>
                                     <input onChange={(e) => { changeHna(e, setFieldValue) }} value={values.max_attendees} name="max_attendees" type="text" className="input-in-availbilities" />
                                    <span className="error">
                                        {errors.max_attendees &&
                                          touched.max_attendees &&
                                          errors.max_attendees
                                          ? t("appointment.enterAttendeesError")
                                          : ""}
                                      </span>
                                       </>
                                    )}
                                      {clientMediumAttendees && (
                                         <>
                                    <div className="row">
                                      <div className="col-md-3">
                                  <span>{t("appointment.totalAttendees")}</span> 
                                   </div>
                                   <div className="col-md-9">
                                   <input onChange={(e) => { changeHna(e, setFieldValue) }} value={values.max_attendees} name="max_attendees" type="text" className="input-in-availbilities" />
                                    <span className="error">
                                        {errors.max_attendees &&
                                          touched.max_attendees &&
                                          errors.max_attendees
                                          ? t("appointment.enterAttendeesError")
                                          : ""}
                                      </span>
                                      </div>
                                      </div>
                                      <div className="row">
                                      <div className="col-md-3">
                                  <span>{t("appointment.maxMediums")}</span> 
                                   </div>
                                   <div className="col-md-9">
                                   <input onChange={(e) => { changeHnadMedium(e, setFieldValue) }} value={values.max_mediums || ""} name="max_mediums" type="text" className="input-in-availbilities" />
                                    <span className="error">
                                        {errors.max_mediums &&
                                          touched.max_mediums &&
                                          errors.max_mediums
                                          ? t("appointment.enterAttendeesError")
                                          : ""}
                                      </span>
                                      </div>
                                      </div>
                                      </>
                                    )}
                                  </div>

                                </div>

                                <div className="preferencesfilde-right">
                                  {" "}

                                </div>
                                </>
          )}

                                {priceForAttendee && show30Min &&<div className="preferencesfilde-right">
                                  {" "}
                                  
                                  <span>{t("appointment.priceForAttendees")} {(!showDevelopmentCircles || hasSubSession83)  && <b>{t("appointment.tbd")}</b>}</span>
                                  <div class="select-dropdown">
                                    <input
                                      onChange={(e) => { changePriceForattendees(e, setFieldValue) }}
                                      value={values.price_for_attendees} name="price_for_attendees"
                                      type="text" className="input-in-availbilities" />
                                  </div>
                                </div>
                                }
                                {/* } */}
                                <div className="preferencesfilde-right">
                                  {" "}

                                </div>

                                <div className="scheduling-preferencesfilde">
                                  <div className="preferencesfilde-left">
                                    {" "}
                                     {" "}
                                     {additionalWorker &&  showGroupSession &&<>
                              <span>{t("appointment.additionalWorkers")}</span>
                              <div class="select-dropdown">
                                <select
                                  value={values.additional_worker}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name={`additional_worker`}
                                  defaultValue={1}
                                >
                                  <option disabled selected value="">
                                    {t("appointment.selectAdditionalWorker")}
                                  </option>
                                  <option value={0}>0</option>
                                  <option value={1}>1</option>
                                  <option value={2}>2</option>
                                  <option value={3}>3</option>
                                  <option value={4}>4</option>

                                </select>
                              </div>
                              </>}
                                  </div>
                                   {priceForAttendee && show30Min &&
                                  <div className="preferencesfilde-left">
                                   <p className="noteCurrency"> {t("appointment.currencyNote")}</p>

                                  </div>
                                  }

                                  {priceForAttendee && show30Min &&
                                    <div className="preferencesfilde-right">
                                      {" "}
                                      <span>{t("appointment.sessionCurrency")}</span>

                                      <>
                                        <div className="row-one-step p-2">
                                          <div className="full-side">

                                            {/* stepOneData.mediumship_level */}
                                            <div className="full-fild ml-5">
                                              <>
                                                <div className="check-field">
                                                  <input
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    type="radio"
                                                    name="session_currency"
                                                    id="session_currency_usd"
                                                    value={"USD"}
                                                    checked={
                                                      values.session_currency === "USD"
                                                        ? true
                                                        : false
                                                    }

                                                  // checked={
                                                  //   parseInt(values.when_do_i_pay) === 1 ? true : false
                                                  // }
                                                  />
                                                  <label
                                                    className=" w-unset"
                                                    htmlFor="when_do_i_pay_1"
                                                  >
                                                    USD
                                                  </label>
                                                </div>
                                                <div className="check-field">
                                                  <input
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    type="radio"
                                                    name="session_currency"
                                                    id="session_currency_cad"
                                                    value={"CAD"}
                                                    checked={
                                                      values.session_currency === "CAD"
                                                        ? true
                                                        : false
                                                    }

                                                  // checked={
                                                  //   parseInt(values.when_do_i_pay) === 1 ? true : false
                                                  // }
                                                  />
                                                  <label
                                                    className=" w-unset"
                                                    htmlFor="when_do_i_pay_1"
                                                  >
                                                    CAD
                                                  </label>
                                                </div>
                                                <div className="check-field">
                                                  <input
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    type="radio"
                                                    name="session_currency"
                                                    id="session_currency_aud"
                                                    value={"AUD"}
                                                    checked={
                                                      values.session_currency === "AUD"
                                                        ? true
                                                        : false
                                                    }

                                                  // checked={
                                                  //   parseInt(values.when_do_i_pay) === 1 ? true : false
                                                  // }
                                                  />
                                                  <label
                                                    className=" w-unset"
                                                    htmlFor="when_do_i_pay_1"
                                                  >
                                                    AUD
                                                  </label>
                                                </div>
                                                 <div className="check-field">
                                                  <input
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    type="radio"
                                                    name="session_currency"
                                                    id="session_currency_eur"
                                                    value={"EUR"}
                                                    checked={
                                                      values.session_currency === "EUR"
                                                        ? true
                                                        : false
                                                    }

                                                  // checked={
                                                  //   parseInt(values.when_do_i_pay) === 1 ? true : false
                                                  // }
                                                  />
                                                  <label
                                                    className=" w-unset"
                                                    htmlFor="when_do_i_pay_1"
                                                  >
                                                    EUR
                                                  </label>
                                                </div>
                                              </>
                                            </div>
                                          </div>
                                        </div>

                                      </>
                                      {showPayForward && (<span className="red">{t("appointment.payForwardNote")}</span>)}

                                    </div>
                                  }
                                  <div className="preferencesfilde-right">
                                    {" "}

                                  </div>
                                </div>
                              </div>

                            {/************** */}
                          </div>

                          <div className="minimum-booking-time-row">
                            <div className="minimum-booking-time-row-left">
                              <label className="strclint golden-icon min-booking-tooltip tooltip-1-focus ">
                                {t("appointment.minBookingTime")}
                              </label>
                              {/***tooltip here */}
                              <div className="tooltip-1 min-booking-tooltip-1">
                                {t("appointment.minBookingTooltip")}
                              </div>
                              <div className="new-three-bx">
                                {/************ */}
                                <div className="minimum-inner-row-left">
                                  {" "}
                                  <span>{t("appointment.unit")}</span>
                                  <div class="select-dropdown">
                                    <select
                                      value={unitValue}
                                      name="minunitchange"
                                      onChange={(e) => unitChangeHandler(e, setFieldValue)}
                                    >
                                      <option value="Days">
                                        {t("units.days")}
                                      </option>
                                      <option value="Hours">
                                        {t("units.hours")}
                                      </option>
                                      <option value="Minutes">
                                        {t("units.minutes")}
                                      </option>

                                    </select>
                                  </div>
                                </div>
                                {/*********** */}
                                {unitValue === 'Days' && <div className="minimum-inner-row-left">
                                  {" "}
                                  <span>{t("units.days")}</span>
                                  <div class="select-dropdown">
                                    <select
                                      value={values.min_booking_days}
                                      name="min_booking_days"
                                      onChange={(e) => handleMinDaysChange(e, setFieldValue)}
                                      onBlur={handleBlur}
                                    >
                                      <option disabled selected value="">
                                        {t("units.days")}
                                      </option>
                                      <option value={0}>00</option>
                                      {makeHours(31).map((item) => (
                                        <option selected={item === '01' ? true : false} value={item}>{item}</option>
                                      ))}
                                    </select>
                                  </div>
                                </div>}
                                {unitValue === 'Hours' && <div className="minimum-inner-row-left clear-both mt-2">
                                  {" "}
                                  <span>{t("units.hours")}</span>
                                  <div class="select-dropdown">
                                    <select
                                      value={values.min_booking_hour}
                                      name="min_booking_hour"
                                      onChange={(e) => handleMinHoursChange(e, setFieldValue)}
                                      onBlur={handleBlur}
                                    >
                                      <option disabled selected value="">
                                        {t("units.hours")}
                                      </option>
                                      <option value={0}>00</option>
                                      {makeHours(24).map((item) => (
                                        <option selected={item === '01' ? true : false} value={item}>{item}</option>
                                      ))}
                                    </select>
                                  </div>
                                </div>}
                                {unitValue === 'Minutes' && <div className="minimum-inner-row-left clear-both mt-2">
                                  {" "}
                                  <span>{t("units.min")}</span>
                                  <div class="select-dropdown">
                                    <select
                                      value={values.min_booking_time}
                                      name="min_booking_time"
                                      onChange={(e) => handleMinTimeChange(e, setFieldValue)}
                                      onBlur={handleBlur}
                                    >
                                      <option disabled selected value="">
                                        {t("units.minutes")}
                                      </option>
                                      <option value={0}>00</option>
                                      <option value="15" selected>15</option>
                                      <option value="30">30</option>
                                      <option value="45">45</option>
                                      {/* {makeHours(59).map((item) => (
                                      <option value={`${item}`}>{item}</option>
                                    ))} */}
                                      {/* {console.log(makeHours(59),"makeHours(59)")} */}
                                    </select>
                                  </div>
                                </div>}
                              </div>
                            </div>
                            {/* {!showGroupSession && ( */}
                            <div className="minimum-booking-time-row-right">
                              <label className="strclint  golden-icon min-booking-tooltip tooltip-2-focus">
                                {t("appointment.maxBookingTime")}
                              </label>
                              <div className="tooltip-2 min-booking-tooltip-1">
                                {t("appointment.maxBookingTooltip")}
                              </div>
                              <div className="minimum-inner-row-left">
                                {" "}
                                <span>{t("units.days")}</span>
                                <div class="select-dropdown">
                                  <select
                                    value={values.max_booking_days}
                                    name="max_booking_days"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  >
                                    <option disabled selected value="">
                                      {t("units.days")}
                                    </option>
                                    <option value={360}>{t("appointment.unlimited")}</option>
                                    {makeHours(31).map((item) => (
                                      <option value={item}>{item}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            {/* )} */}
                          </div>
                          {showNoOfSesionPerDay && (
                            <BookingPeriodBar values={values} />
                          )}

                          <div className="meeting-preferences-box-row">
                            <h4>{t("meeting.title")}</h4>
                            <div className="language-box--row">
                              {" "}
                              <span>{t("meeting.languageRequirement")}</span>
                              {/* <span>Language</span> */}
                              <div class="select-dropdown">
                                <Select
                                  id="meeting_preferences_meeting"
                                  className="assign-level-select width-530-px"
                                  options={languages}
                                  isMulti={showMuliLanguage}
                                  onChange={(value) =>
                                    setFieldValue(
                                      "meeting_preferences_meeting",
                                      showMuliLanguage ? value : [value]
                                    )
                                  }
                                  // onBlur={handleBlur}
                                  placeholder=""
                                  value={values.meeting_preferences_meeting}
                                  closeMenuOnSelect={false}
                                  closeMenuOnScroll={false}
                                />
                              </div>
                            </div>
                            <div className="recording-box--row">
                              {" "}
                              <div class="select-dropdown margin-top-recording">
                                <span>{t("meeting.recording")}</span>
                                <select
                                  name="recording"
                                  value={values.recording}
                                  onChange={handleChange}
                                  onBlur={handleBlur}

                                >
                                  {/* <option disabled selected value="">
                          Recording
                        </option> */}
                                  <option value={1}>{t("meeting.yes")}</option>
                                  <option value={0}>{t("meeting.no")}</option>
                                </select>
                              </div>
                            </div>
                            {/* {type === "admin" && (
                    <div className="group-limit-box--row">
                      {" "}
                      <span>Group Limit</span>
                      <div class="select-dropdown">
                        <select
                          name="group_limit"
                          value={values.group_limit}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option disabled selected value="">
                            Group Limit
                          </option>

                          <option value={500}>500</option>
                          <option value={100}>100</option>
                          <option value={50}>50</option>
                          <option value={10}>10</option>
                        </select>
                      </div>
                    </div>
                  )} */}
                          </div>
                          <div className="meeting-preferences-box-row  mt-top clear-both">
                            <h4>{t("participants.title")}</h4>
                            <div className="language-box--row clear-both d-flex">
                              {" "}
                              <span>{t("participants.countries")}</span>
                              <div className="ml-3">
                                <div className="check-field">
                                  <input
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value="All Countries"
                                    id="allcountries"
                                    defaultChecked={
                                      values.country_type === "All Countries"
                                        ? true
                                        : false
                                    }
                                    name="country_type"
                                    type="radio"
                                  />
                                  <label htmlFor="my-check">
                                    {t("participants.allCountries")}
                                  </label>
                                </div>
                                <div className="check-field">
                                  <input
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value="All Countries with Exclusions"
                                    id="exclusioncountries"
                                    name="country_type"
                                    defaultChecked={
                                      values.country_type ===
                                        "All Countries with Exclusions"
                                        ? true
                                        : false
                                    }
                                    type="radio"
                                  />
                                  <label htmlFor="my-checktow">
                                    {t("participants.allWithExclusions")}
                                  </label>
                                </div>
                                <div className="check-field">
                                  <input
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value="Selected Countries only"
                                    defaultChecked={
                                      values.country_type ===
                                        "Selected Countries only"
                                        ? true
                                        : false
                                    }
                                    id="selectedcountries"
                                    name="country_type"
                                    type="radio"
                                  />
                                  <label htmlFor="my-checktow">
                                    {t("participants.selectedOnly")}
                                  </label>
                                </div>
                              </div>
                            </div>
                            {values.country_type !== "All Countries" &&
                              values.country_type !== "" && (
                                <div className="row-one-step student-lavel">
                                  <div className="full-fild">
                                    <label>
                                      {values.country_type ===
                                        "All Countries with Exclusions"
                                        ? t("participants.selectExclusions")
                                        : t("participants.selectCountries")}
                                    </label>
                                    <Select
                                      id="country"
                                      className="selection-box"
                                      options={newCountryData}
                                      multi={true}
                                      isMulti
                                      onChange={
                                        values.country_type ===
                                          "All Countries with Exclusions"
                                          ? (value) =>
                                            setFieldValue("exclusions", value)
                                          : (value) =>
                                            setFieldValue("inclusions", value)
                                      }
                                      onBlur={handleBlur}
                                      placeholder={
                                        values.country_type ===
                                          "All Countries with Exclusions"
                                          ? t("participants.selectExclusionPlaceholder")
                                          : t("participants.selectCountryPlaceholder")
                                      }
                                      value={
                                        values.country_type ===
                                          "All Countries with Exclusions"
                                          ? values.exclusions
                                          : values.inclusions
                                      }
                                      closeMenuOnSelect={false}
                                      closeMenuOnScroll={false}

                                    />
                                    <br />
                                    <p className="error">
                                      {values.country_type === "Selected Countries only" && errors.inclusions &&
                                        touched.inclusions &&
                                        errors.inclusions ||
                                        values.country_type === "All Countries with Exclusions" && errors.exclusions &&
                                        touched.exclusions &&
                                        errors.exclusions ? t("participants.selectCountriesError") : ""}
                                    </p>
                                  </div>
                                </div>
                              )}
                            {/* <div class="select-dropdown">
                                <Select
                                  id="meeting_preferences_participants"
                                  className="assign-level-select width-530-px"
                                  options={countries}
                                  isMulti
                                  onChange={(value) =>
                                    setFieldValue(
                                      "meeting_preferences_participants",
                                      value
                                    )
                                  }
                                  // onBlur={handleBlur}
                                  placeholder=""
                                  value={
                                    values.meeting_preferences_participants
                                  }
                                  closeMenuOnSelect={false}
                                  closeMenuOnScroll={false}
                                />
                              </div> */}

                            {/* <div className="recording-box--row">
                    {" "}
                    <span>Recording</span>
                    <div class="select-dropdown">
                      <select
                        name="recording_participants"
                        value={values.recording_participants}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option disabled selected value="">
                          Recording
                        </option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>
                  </div> */}
                          </div>
                          {/*********** */}

                          {showpreffered &&
                            <div className="meeting-preferences-box-row clear-both">
                              { }
                              <h4>{t("levels.title")}



                                {disablePreferredType && <p className="font-size-11 d-inline">{t("levels.comingSoon")}</p>}
                              </h4>

                              <div className="check-field">

                                <div className={`check-field mt-3 ${disablePreferredType ? 'select_partner_level' : ''}`}>
                                  <input
                                    // onChange={(e) => checkPreferedMediums(e, setFieldValue, values)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={1}
                                    id="novice"
                                    disabled={disablePreferredType}
                                    // selected={item.status}

                                    checked={values.preferred_medium_level.includes("1") ? "checked" : ""}
                                    type="checkbox"
                                    name="preferred_medium_level"
                                  />

                                  <label htmlFor="">{t("levels.novice1")}</label>
                                </div>
                                <div className={`check-field mt-3 ${disablePreferredType ? 'select_partner_level' : ''}`}>
                                  <input
                                    // onChange={(e) => checkPreferedMediums(e, setFieldValue, values)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={4}
                                    id="novice2"
                                    disabled={disablePreferredType}
                                    // selected={item.status}

                                    checked={values.preferred_medium_level.includes("4") ? "checked" : ""}
                                    type="checkbox"
                                    name="preferred_medium_level"
                                  />

                                  <label htmlFor="novice2">{t("levels.novice2")}</label>
                                </div>
                                <div className={`check-field mt-3 ${disablePreferredType ? 'select_partner_level' : ''}`}>
                                  <input
                                    // onChange={(e) => checkPreferedMediums(e, setFieldValue, values)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={2}
                                    disabled={disablePreferredType}
                                    id="Intermediate"
                                    // selected={item.status}

                                    checked={values.preferred_medium_level.includes("2") ? "checked" : ""}
                                    type="checkbox"
                                    name="preferred_medium_level"
                                  />
                                  {/* {console.log(item.status,"approvedPrefrences")} */}
                                  <label htmlFor="">{t("levels.intermediate1")}</label>
                                </div>
                                <div className={`check-field mt-3 ${disablePreferredType ? 'select_partner_level' : ''}`}>
                                  <input
                                    // onChange={(e) => checkPreferedMediums(e, setFieldValue, values)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={5}
                                    disabled={disablePreferredType}
                                    id="Intermediate2"
                                    // selected={item.status}

                                    checked={values.preferred_medium_level.includes("5") ? "checked" : ""}
                                    type="checkbox"
                                    name="preferred_medium_level"
                                  />
                                  {/* {console.log(item.status,"approvedPrefrences")} */}
                                  <label htmlFor="">{t("levels.intermediate2")}</label>
                                </div>
                                <div className={`check-field mt-3 ${disablePreferredType ? 'select_partner_level' : ''}`}>
                                  {/* {console.log(checkPreferedType(type, values), "checkPrefer,setshowprefferededType(type, values, 3)")} */}
                                  <input
                                    // onChange={(e) => checkPreferedMediums(e, setFieldValue, values)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={3}
                                    disabled={disablePreferredType}
                                    id="Professional3"
                                    // selected={item.status}
                                    checked={values.preferred_medium_level.includes("3") ? "checked" : ""}

                                    type="checkbox"
                                    name="preferred_medium_level"
                                  />
                                  {/* {console.log(item.status,"approvedPrefrences")} */}
                                  <label htmlFor="">{t("levels.professional1")}</label>
                                </div>

                                <div className={`check-field mt-3 ${disablePreferredType ? 'select_partner_level' : ''}`}>
                                  {/* {console.log(checkPreferedType(type, values), "checkPrefer,setshowprefferededType(type, values, 3)")} */}
                                  <input
                                    // onChange={(e) => checkPreferedMediums(e, setFieldValue, values)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={6}
                                    disabled={disablePreferredType}
                                    id="Professional3"
                                    // selected={item.status}
                                    checked={values.preferred_medium_level.includes("6") ? "checked" : ""}

                                    type="checkbox"
                                    name="preferred_medium_level"
                                  />
                                  {/* {console.log(item.status,"approvedPrefrences")} */}
                                  <label htmlFor="">{t("levels.professional2")}</label>
                                </div>
                                <div className={`check-field mt-3 ${disablePreferredType ? 'select_partner_level' : ''}`}>
                                  {/* {console.log(checkPreferedType(type, values), "checkPrefer,setshowprefferededType(type, values, 3)")} */}
                                  <input
                                    // onChange={(e) => checkPreferedMediums(e, setFieldValue, values)}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={7}
                                    disabled={disablePreferredType}
                                    id="Professional3"
                                    // selected={item.status}
                                    checked={values.preferred_medium_level.includes("7") ? "checked" : ""}

                                    type="checkbox"
                                    name="preferred_medium_level"
                                  />
                                  {/* {console.log(item.status,"approvedPrefrences")} */}
                                  <label htmlFor="">{t("levels.professional3")}</label>
                                </div>
                              </div>
                              <p className="error">
                                {errors.preferred_medium_level}
                              </p>
                            </div>
                          }
                          {/*********** */}
                          <div className="meeting-preferences-box-row">
                            {showField && (
                              <div className="language-box--row clear-both mb-5">
                                {" "}
                                <span>{t("levels.studentLevel")}</span>
                                <div class="select-dropdown">
                                  <Select
                                    id="student_level"
                                    className="assign-level-select width-530-px mb-2"
                                    options={mediumRolesStudentList}
                                    isMulti
                                    onChange={(value) =>
                                      setFieldValue("student_level", value)
                                    }
                                    // onBlur={handleBlur}
                                    placeholder=""
                                    value={values.student_level}
                                    closeMenuOnSelect={false}
                                    closeMenuOnScroll={false}
                                  />
                                </div>
                                {/* <div class="select-dropdown">
                      {console.log(values, "valuesvalues")}
                      <select
                        name="student_level"
                        value={values.student_level}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <option disabled selected value="">
                          Student Level
                        </option>
                        {mediumRolesStudent.map((data) => (
                          <option value={data.id}>{data.name}</option>
                        ))}
                      </select>
                    </div> */}
                              </div>
                            )}
                            {/* {ParticipantLevelStatus && (
                              <div className="language-box--row clear-both mt-5">
                                {" "}
                                <span>Participant Level</span>
                                <div class="select-dropdown">
                                  <Select
                                    id="partner_level"
                                    className="assign-level-select width-530-px mt-2"
                                    options={mediumRolesList}
                                    isMulti
                                    onChange={(value) =>
                                      setFieldValue("partner_level", value)
                                    }

                                    placeholder=""
                                    value={values.partner_level}
                                    closeMenuOnSelect={false}
                                    closeMenuOnScroll={false}
                                  />
                                </div>

                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*******Appointment setting end */}


              {showGroup && !WeeklyGroupEvents && (
                <div className="calendar-box-new">
                  <div id="accordion">
                    <div class="card">
                      <div class="card-header" id={"heading-1"}>
                        <h5 class="mb-0">
                          <a
                            class="collapsed"
                            role="button"
                            data-toggle="collapse"
                            href={"#collapse-4"}
                            aria-expanded={collapsed === "collapse" ? "false" : "true"}
                            aria-controls={"collapse-4"}
                          >
                            {""}
                            {checkIsGroupSessionTitles(values, t("weekly.groupTitle"), t("weekly.title"))}{" "}
                            {/* {"Add Weekly Hours"}{" "} */}
                          </a>
                        </h5>


                        {/* <div className="scheduling-preferences-saction">
                <h3>Scheduling Preferences</h3> */}
                        <div
                          id={"collapse-4"}
                          class={collapsed}
                          data-parent="#accordion"
                          aria-labelledby={"heading-1"}
                        >
                          <div class="card-body">
                            <div className="availability-window-table">
                              <table>
                                <tbody>
                                  <tr>
                                    <th>{checkIsGroupSessionTitles(values, t("weekly.everyDayAt"), t("units.days"))}
                                      {/* Days */}
                                    </th>
                                    <th>{checkIsGroupSessionTitles(values, t("time.startTime"), t("time.startAt"))}
                                      {/* Start at */}
                                    </th>
                                    <th className="position-relative">{checkIsGroupSessionTitles(values, t("time.endTime"), t("time.endAt"))}
                                      {checkIsGroupSessionTitles(values, "End Time", 'End at') === "End Time" && <span className="ml-1">
                                        <span className="strclint golden-icon min-booking-tooltip tooltip-1-focus "></span>
                                        <div className="tooltip-1  end-time-tooltip-1 end-timetool-text">
                                          {t("weekly.endTimeTooltip")}
                                        </div>
                                      </span>}
                                      {/* End at */}
                                    </th>
                                    <th></th>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-group">
                                        <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="daysunday"
                                          checked={
                                            values.daysunday ||
                                            values.scheduleSunday[0].from !== ""
                                          }
                                          type="checkbox"
                                          name="daysunday"
                                          id="daysunday"
                                        />
                                        <label for="daysunday">{t("days.sunday")}</label>
                                      </div>
                                      <div className="box-valid-from-three">
                                        <div id="copy-modal" class="modal">
                                          <div class="modal__content">
                                            {" "}
                                            <a href="#" class="modal__close">
                                              &times;
                                            </a>
                                            <div className="header-popup-specifc text-center">
                                              <span>{t("copyModal.title")}</span>
                                            </div>
                                            <div className="mt-3">
                                              {" "}
                                              {t("copyModal.selectedDay")}
                                              <em className="dbb38f">
                                                {" "}
                                                {activeCopy ? t(`days.${activeCopy}`, { defaultValue: capitalizeFirstLetter(activeCopy) }) : capitalizeFirstLetter(activeCopy)}
                                              </em>{" "}
                                            </div>
                                            <div className="header-popup-specifc-body copy-container mt-4 d-flex align-items-center ">
                                              {activeCopy !== "sunday" && (
                                                <div class="form-group">
                                                  <input
                                                    onChange={copyChangeHandler}
                                                    type="checkbox"
                                                    value={"sunday"}
                                                    name="copydays"
                                                    id="sunday"
                                                  />
                                                  <label
                                                    className="mr-3"
                                                    for="sunday"
                                                  >
                                                    {t("days.sunday")}
                                                  </label>
                                                </div>
                                              )}
                                              {activeCopy !== "monday" && (
                                                <div class="form-group">
                                                  <input
                                                    onChange={copyChangeHandler}
                                                    value={"monday"}
                                                    type="checkbox"
                                                    id="monday"
                                                    name="copydays"
                                                  />
                                                  <label
                                                    className="mr-3"
                                                    for="monday"
                                                  >
                                                    {t("days.monday")}
                                                  </label>
                                                </div>
                                              )}
                                              {activeCopy !== "tuesday" && (
                                                <div class="form-group">
                                                  <input
                                                    onChange={copyChangeHandler}
                                                    value={"tuesday"}
                                                    type="checkbox"
                                                    id="tuesday"
                                                    name="copydays"
                                                  />
                                                  <label
                                                    className="mr-3"
                                                    for="tuesday"
                                                  >
                                                    {t("days.tuesday")}
                                                  </label>
                                                </div>
                                              )}
                                              {activeCopy !== "wednesday" && (
                                                <div class="form-group">
                                                  <input
                                                    onChange={copyChangeHandler}
                                                    value={"wednesday"}
                                                    type="checkbox"
                                                    id="wednesday"
                                                    name="copydays"
                                                  />
                                                  <label
                                                    className="mr-3"
                                                    for="wednesday"
                                                  >
                                                    {t("days.wednesday")}
                                                  </label>
                                                </div>
                                              )}
                                              {activeCopy !== "thursday" && (
                                                <div class="form-group">
                                                  <input
                                                    onChange={copyChangeHandler}
                                                    value={"thursday"}
                                                    type="checkbox"
                                                    id="thursday"
                                                    name="copydays"
                                                  />
                                                  <label
                                                    className="mr-3"
                                                    for="thursday"
                                                  >
                                                    {t("days.thursday")}
                                                  </label>
                                                </div>
                                              )}
                                              {activeCopy !== "friday" && (
                                                <div class="form-group">
                                                  <input
                                                    onChange={copyChangeHandler}
                                                    value={"friday"}
                                                    type="checkbox"
                                                    id="friday"
                                                    name="copydays"
                                                  />
                                                  <label
                                                    className="mr-3"
                                                    for="friday"
                                                  >
                                                    {t("days.friday")}
                                                  </label>
                                                </div>
                                              )}
                                              {activeCopy !== "saturday" && (
                                                <div class="form-group">
                                                  <input
                                                    onChange={copyChangeHandler}
                                                    value={"saturday"}
                                                    type="checkbox"
                                                    id="saturday"
                                                    name="copydays"
                                                  />
                                                  <label
                                                    className="mr-3"
                                                    for="saturday"
                                                  >
                                                    {t("days.saturday")}
                                                  </label>
                                                </div>
                                              )}
                                            </div>
                                            <div className="text-center mt-3">
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  copyHandler(values, setFieldValue)
                                                }
                                                className="copy-btn-days"
                                              >
                                                {t("copyModal.copy")}
                                              </button>
                                            </div>
                                          </div>
                                        </div>{" "}
                                      </div>
                                    </td>
                                    <FieldArray name="scheduleSunday">
                                      {({ insert, remove, push }) => (
                                        <td colspan="3">
                                          <div className="d-flex">
                                            <div className="">
                                              {values.scheduleSunday.length > 0 &&
                                                values.scheduleSunday.map(
                                                  (schedule, index) => (
                                                    <div className="d-flex justify-content-between width-530-px mb-2">
                                                      {/* <td> */}
                                                      <div class="select-dropdown">
                                                        {/* <label for="hours">Hours</label> */}
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleSunday.${index}.from`}

                                                          //  menuIsOpen
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from", "day"
                                                          //   )
                                                          // }
                                                          //  ref={selectRef}
                                                          onMenuOpen={values.scheduleSunday[index].from === "" ? () =>
                                                            scrollMenuToTarget(
                                                              "from", "day"
                                                            ) : onMenuOpen}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleSunday.${index}.from`,
                                                              values,
                                                              "scheduleSunday",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}
                                                          // closeMenuOnSelect={false}
                                                          // closeMenuOnScroll={false}
                                                          options={slotsList}
                                                          // menuPortalTarget={startPoint}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.from}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            id={`scheduleSunday.${index}.from`}
                                            value={schedule.from}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name={`scheduleSunday.${index}.from`}
                                            placeholder="Hours"
                                          />

                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option value={item.time}>

                                              </option>
                                            ))}
                                          </datalist> */}
                                                      </div>
                                                      {/* </td> */}
                                                      {/* <td> */}
                                                      <div class="select-dropdown d-flex">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleSunday.${index}.to`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleSunday.${index}.to`,
                                                              values,
                                                              "scheduleSunday",
                                                              "to",
                                                              values.scheduleSunday[index].from
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          // options={slotsList}
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                schedule.from
                                                                  .value
                                                              )
                                                          )}
                                                          // ref={selectRef}
                                                          onMenuOpen={onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to", "day"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />

                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {values.scheduleSunday.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .scheduleSunday[0]
                                                            .from !== "" ? (
                                                            <img
                                                              onClick={() =>
                                                                // remove(index)
                                                                removefirstArray(
                                                                  "scheduleSunday",
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                            <div className="w-100 d-flex justify-content-around align-items-center">
                                              <span
                                                onClick={() =>
                                                  push({ from: "", to: "" })
                                                }
                                                className="span-tag pointer"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                              <a
                                                href="#copy-modal"
                                                onClick={() =>
                                                  setActiveCopy("sunday")
                                                }
                                                className="span-tag pointer"
                                              >
                                                {t("weekly.copyLink")}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                      )}
                                    </FieldArray>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-group">
                                        <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="daymonday"
                                          checked={
                                            values.daymonday ||
                                            values.scheduleMonday[0].from !== ""
                                          }
                                          type="checkbox"
                                          name="daymonday"
                                          id="daymonday"
                                        />
                                        <label for="daymonday">{t("days.monday")}</label>
                                      </div>
                                    </td>
                                    <FieldArray name="scheduleMonday">
                                      {({ insert, remove, push }) => (
                                        <td colspan="3">
                                          <div className="d-flex">
                                            <div className="">
                                              {values.scheduleMonday.length > 0 &&
                                                values.scheduleMonday.map(
                                                  (schedule, index) => (
                                                    <div className="d-flex justify-content-between width-530-px mb-2">
                                                      {/* <td> */}
                                                      <div class="select-dropdown">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleMonday.${index}.from`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleMonday.${index}.from`,
                                                              values,
                                                              "scheduleMonday",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList}
                                                          onMenuOpen={values.scheduleMonday[index].from === "" ? () =>
                                                            scrollMenuToTarget(
                                                              "from", "day"
                                                            ) : onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from", "day"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.from}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />

                                                        {/* <input
                                            list="hours"
                                            value={schedule.from}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleMonday.${index}.from`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option value={item.time}>

                                              </option>
                                            ))}
                                          </datalist> */}
                                                      </div>
                                                      {/* </td> */}
                                                      {/* <td> */}
                                                      <div class="select-dropdown  d-flex">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleMonday.${index}.to`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleMonday.${index}.to`,
                                                              values,
                                                              "scheduleMonday",
                                                              "to",
                                                              values.scheduleMonday[index].from
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          // options={slotsList}
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                schedule.from
                                                                  .value
                                                              )
                                                          )}
                                                          onMenuOpen={onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to", "day"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {values.scheduleMonday.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .scheduleMonday[0]
                                                            .from !== "" ? (
                                                            <img
                                                              onClick={() =>
                                                                removefirstArray(
                                                                  "scheduleMonday",
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                      {/* </td> */}
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                            {/* <td> */}
                                            <div className="w-100 d-flex justify-content-around align-items-center">
                                              <span
                                                onClick={() =>
                                                  push({ from: "", to: "" })
                                                }
                                                className="span-tag pointer"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                              <a
                                                href="#copy-modal"
                                                // data-toggle="modal"
                                                // data-target="#copy-modal"
                                                onClick={() =>
                                                  setActiveCopy("monday")
                                                }
                                                className="span-tag pointer"
                                              >
                                                {t("weekly.copyLink")}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                        // </td>
                                      )}
                                    </FieldArray>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-group">
                                        <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="daytuesday"
                                          checked={
                                            values.daytuesday ||
                                            values.scheduleTuesday[0].from !== ""
                                          }
                                          type="checkbox"
                                          name="daytuesday"
                                          id="daytuesday"
                                        />
                                        <label for="daytuesday">{t("days.tuesday")}</label>
                                      </div>
                                    </td>
                                    <FieldArray name="scheduleTuesday">
                                      {({ insert, remove, push }) => (
                                        <td colspan="3">
                                          <div className="d-flex">
                                            <div className="">
                                              {values.scheduleTuesday.length >
                                                0 &&
                                                values.scheduleTuesday.map(
                                                  (schedule, index) => (
                                                    <>
                                                      <div className="d-flex justify-content-between width-530-px mb-2">
                                                        {/* <td> */}
                                                        <div class="select-dropdown">
                                                          <Select
                                                            className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                            id={`scheduleTuesday.${index}.from`}
                                                            onChange={(value) =>
                                                              customChangeHandler(
                                                                index,
                                                                value,
                                                                setFieldValue,
                                                                `scheduleTuesday.${index}.from`,
                                                                values,
                                                                "scheduleTuesday",
                                                                "from"
                                                              )
                                                            }
                                                            onBlur={handleBlur}
                                                            closeMenuOnScroll={
                                                              false
                                                            }
                                                            options={slotsList}
                                                            // onMenuOpen={() =>
                                                            //   scrollMenuToTarget(
                                                            //     "from", "day"
                                                            //   )
                                                            // }
                                                            onMenuOpen={values.scheduleTuesday[index].from === "" ? () =>
                                                              scrollMenuToTarget(
                                                                "from", "day"
                                                              ) : onMenuOpen}
                                                            placeholder={t("time.hoursPlaceholder")}
                                                            filterOption={
                                                              customFilter
                                                            }
                                                            value={schedule.from}
                                                            formatOptionLabel={(
                                                              slotsList
                                                            ) =>
                                                              getTimeImage(
                                                                slotsList.value
                                                              ) ? (
                                                                <div className="time-option">
                                                                  <span>
                                                                    {slotsList.value ==
                                                                      "11:59 PM"
                                                                      ? "12:00 AM"
                                                                      : slotsList.value}
                                                                  </span>
                                                                  &nbsp;&nbsp;
                                                                  <img
                                                                    src="localImages/moon.png"
                                                                    className="star-imh-moon"
                                                                    alt="time-image"
                                                                  />
                                                                </div>
                                                              ) : (
                                                                <div className="time-option">
                                                                  <span>
                                                                    {slotsList.value ==
                                                                      "11:59 PM"
                                                                      ? "12:00 AM"
                                                                      : slotsList.value}
                                                                  </span>
                                                                </div>
                                                              )
                                                            }
                                                          />
                                                          {/* <input
                                              list="hours"
                                              ̀̀value={schedule.from}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              placeholder="Hours"
                                              name={`scheduleTuesday.${index}.from`}
                                            />

                                            <datalist id="hours">
                                              {slotsArray.map((item) => (
                                                <option value={item.time}>

                                                </option>
                                              ))}
                                            </datalist> */}
                                                        </div>
                                                        {/* </td> */}
                                                        {/* <td> */}
                                                        <div class="select-dropdown  d-flex">
                                                          <Select
                                                            className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                            id={`scheduleTuesday.${index}.to`}
                                                            onChange={(value) =>
                                                              customChangeHandler(
                                                                index,
                                                                value,
                                                                setFieldValue,
                                                                `scheduleTuesday.${index}.to`,
                                                                values,
                                                                "scheduleTuesday",
                                                                "to",
                                                                values.scheduleTuesday[index].from
                                                              )
                                                            }
                                                            onBlur={handleBlur}
                                                            closeMenuOnScroll={
                                                              false
                                                            }
                                                            // options={slotsList}
                                                            // onMenuOpen={() =>
                                                            //   scrollMenuToTarget(
                                                            //     "to", "day"
                                                            //   )
                                                            // }
                                                            onMenuOpen={onMenuOpen}
                                                            options={slotsList.filter(
                                                              (option, index) =>
                                                                formatTimeTo24hrs(
                                                                  option.value
                                                                ) >
                                                                formatTimeTo24hrs(
                                                                  schedule.from
                                                                    .value
                                                                )
                                                            )}
                                                            placeholder={t("time.hoursPlaceholder")}
                                                            filterOption={
                                                              customFilter
                                                            }
                                                            value={schedule.to}
                                                            formatOptionLabel={(
                                                              slotsList
                                                            ) =>
                                                              getTimeImage(
                                                                slotsList.value
                                                              ) ? (
                                                                <div className="time-option">
                                                                  <span>
                                                                    {slotsList.value ==
                                                                      "11:59 PM"
                                                                      ? "12:00 AM"
                                                                      : slotsList.value}
                                                                  </span>
                                                                  &nbsp;&nbsp;
                                                                  <img
                                                                    src="localImages/moon.png"
                                                                    className="star-imh-moon"
                                                                    alt="time-image"
                                                                  />
                                                                </div>
                                                              ) : (
                                                                <div className="time-option">
                                                                  <span>
                                                                    {slotsList.value ==
                                                                      "11:59 PM"
                                                                      ? "12:00 AM"
                                                                      : slotsList.value}
                                                                  </span>
                                                                </div>
                                                              )
                                                            }
                                                          />

                                                          <div className="buttion-add-box onclick-button mt-2">
                                                            {values.scheduleTuesday.length > 1 ? (
                                                              <img
                                                                onClick={() =>
                                                                  remove(index)
                                                                }
                                                                className="pointer"
                                                                src="../images/icon-b2.png"
                                                                alt={t("actions.deleteAlt")}
                                                              />
                                                            ) : values
                                                              .scheduleTuesday[0]
                                                              .from !== "" ? (
                                                              <img
                                                                onClick={() =>
                                                                  removefirstArray(
                                                                    "scheduleTuesday",
                                                                    setFieldValue
                                                                  )
                                                                }
                                                                className="pointer"
                                                                src="../images/icon-b2.png"
                                                                alt={t("actions.deleteAlt")}
                                                              />
                                                            ) : (
                                                              <img
                                                                className="hidden-elem"
                                                                src="../images/icon-b2.png"
                                                                alt={t("actions.deleteAlt")}
                                                              />
                                                            )}
                                                          </div>
                                                        </div>
                                                        {/* </td> */}
                                                      </div>
                                                    </>
                                                  )
                                                )}
                                            </div>
                                            {/* <td> */}
                                            <div className="w-100 d-flex justify-content-around align-items-center">
                                              <span
                                                onClick={() =>
                                                  push({ from: "", to: "" })
                                                }
                                                className="span-tag pointer"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                              <a
                                                href="#copy-modal"
                                                // data-toggle="modal"
                                                // data-target="#copy-modal"
                                                onClick={() =>
                                                  setActiveCopy("tuesday")
                                                }
                                                className="span-tag pointer"
                                              >
                                                {t("weekly.copyLink")}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                        // </td>
                                      )}
                                    </FieldArray>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-group">
                                        <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="daywednesday"
                                          checked={
                                            values.daywednesday ||
                                            values.scheduleWednesday[0].from !==
                                            ""
                                          }
                                          type="checkbox"
                                          name="daywednesday"
                                          id="daywednesday"
                                        />
                                        <label for="daywednesday">
                                          {t("days.wednesday")}
                                        </label>
                                      </div>
                                    </td>
                                    <FieldArray name="scheduleWednesday">
                                      {({ insert, remove, push }) => (
                                        <td colspan="3">
                                          <div className="d-flex">
                                            <div className="">
                                              {values.scheduleWednesday.length >
                                                0 &&
                                                values.scheduleWednesday.map(
                                                  (schedule, index) => (
                                                    <div className="d-flex justify-content-between width-530-px mb-2">
                                                      {/* <td> */}
                                                      <div class="select-dropdown">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleWednesday.${index}.from`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleWednesday.${index}.from`,
                                                              values,
                                                              "scheduleWednesday",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from", "day"
                                                          //   )
                                                          // }
                                                          onMenuOpen={values.scheduleWednesday[index].from === "" ? () =>
                                                            scrollMenuToTarget(
                                                              "from", "day"
                                                            ) : onMenuOpen}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.from}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.from}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleWednesday.${index}.from`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option
                                                value={item.time}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                      </div>
                                                      {/* </td> */}
                                                      {/* <td> */}
                                                      <div class="select-dropdown  d-flex">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleWednesday.${index}.to`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleWednesday.${index}.to`,
                                                              values,
                                                              "scheduleWednesday",
                                                              "to",
                                                              values.scheduleWednesday[index].from
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          // options={slotsList}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to", "day"
                                                          //   )
                                                          // }
                                                          onMenuOpen={onMenuOpen}
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                schedule.from
                                                                  .value
                                                              )
                                                          )}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.to}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleWednesday.${index}.to`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option
                                                value={item.time}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {values.scheduleWednesday.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .scheduleWednesday[0]
                                                            .from !== "" ? (
                                                            <img
                                                              onClick={() =>
                                                                removefirstArray(
                                                                  "scheduleWednesday",
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                      {/* </td> */}
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                            {/* <td> */}
                                            <div className="w-100 d-flex justify-content-around align-items-center">
                                              <span
                                                onClick={() =>
                                                  push({ from: "", to: "" })
                                                }
                                                className="span-tag pointer"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                              <a
                                                href="#copy-modal"
                                                // data-toggle="modal"
                                                // data-target="#copy-modal"
                                                onClick={() =>
                                                  setActiveCopy("wednesday")
                                                }
                                                className="span-tag pointer"
                                              >
                                                {t("weekly.copyLink")}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                        // </td>
                                      )}
                                    </FieldArray>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-group">
                                        <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="daythursday"
                                          checked={
                                            values.daythursday ||
                                            values.scheduleThursday[0].from !== ""
                                          }
                                          type="checkbox"
                                          name="daythursday"
                                          id="daythursday"
                                        />
                                        <label for="daythursday">{t("days.thursday")}</label>
                                      </div>
                                    </td>
                                    <FieldArray name="scheduleThursday">
                                      {({ insert, remove, push }) => (
                                        <td colspan="3">
                                          <div className="d-flex">
                                            <div className="">
                                              {values.scheduleThursday.length >
                                                0 &&
                                                values.scheduleThursday.map(
                                                  (schedule, index) => (
                                                    <div className="d-flex justify-content-between width-530-px mb-2">
                                                      {/* <td> */}
                                                      <div class="select-dropdown">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleThursday.${index}.from`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleThursday.${index}.from`,
                                                              values,
                                                              "scheduleThursday",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from", "day"
                                                          //   )
                                                          // }
                                                          onMenuOpen={values.scheduleThursday[index].from === "" ? () =>
                                                            scrollMenuToTarget(
                                                              "from", "day"
                                                            ) : onMenuOpen}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.from}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.from}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleThursday.${index}.from`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option
                                                value={item.time}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                      </div>
                                                      {/* </td> */}
                                                      {/* <td> */}
                                                      <div class="select-dropdown  d-flex">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleThursday.${index}.to`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleThursday.${index}.to
                                                `,
                                                              values,
                                                              "scheduleThursday",
                                                              "to",
                                                              values.scheduleThursday[index].from
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                schedule.from
                                                                  .value
                                                              )
                                                          )}
                                                          // options={slotsList}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to", "day"
                                                          //   )
                                                          // }
                                                          onMenuOpen={onMenuOpen}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.to}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleThursday.${index}.to`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option
                                                value={item.time}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {values.scheduleThursday.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .scheduleThursday[0]
                                                            .from !== "" ? (
                                                            <img
                                                              onClick={() =>
                                                                removefirstArray(
                                                                  "scheduleThursday",
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                      {/* </td> */}
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                            {/* <td> */}
                                            <div className="w-100 d-flex justify-content-around align-items-center">
                                              <span
                                                onClick={() =>
                                                  push({ from: "", to: "" })
                                                }
                                                className="span-tag pointer"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                              <a
                                                href="#copy-modal"
                                                // data-toggle="modal"
                                                // data-target="#copy-modal"
                                                onClick={() =>
                                                  setActiveCopy("thursday")
                                                }
                                                className="span-tag pointer"
                                              >
                                                {t("weekly.copyLink")}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                        // </td>
                                      )}
                                    </FieldArray>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-group">
                                        <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="dayfriday"
                                          checked={
                                            values.dayfriday ||
                                            values.scheduleFriday[0].from !== ""
                                          }
                                          type="checkbox"
                                          name="dayfriday"
                                          id="dayfriday"
                                        />
                                        <label for="dayfriday">{t("days.friday")}</label>
                                      </div>
                                    </td>
                                    <FieldArray name="scheduleFriday">
                                      {({ insert, remove, push }) => (
                                        <td colspan="3">
                                          <div className="d-flex">
                                            <div className="">
                                              {values.scheduleFriday.length > 0 &&
                                                values.scheduleFriday.map(
                                                  (schedule, index) => (
                                                    <div className="d-flex justify-content-between width-530-px mb-2">
                                                      {/* <td> */}
                                                      <div class="select-dropdown">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleFriday.${index}.from`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleFriday.${index}.from`,
                                                              values,
                                                              "scheduleFriday",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList}
                                                          onMenuOpen={values.scheduleFriday[index].from === "" ? () =>
                                                            scrollMenuToTarget(
                                                              "from", "day"
                                                            ) : onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from", "day"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.from}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.from}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            placeholder="Hours"
                                            name={`scheduleFriday.${index}.from`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option
                                                value={item.time}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                      </div>
                                                      {/* </td> */}
                                                      {/* <td> */}
                                                      <div class="select-dropdown  d-flex">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleFriday.${index}.to`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleFriday.${index}.to`,
                                                              values,
                                                              "scheduleFriday",
                                                              "to",
                                                              values.scheduleFriday[index].from
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                schedule.from
                                                                  .value
                                                              )
                                                          )}
                                                          // options={slotsList}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to", "day"
                                                          //   )
                                                          // }
                                                          onMenuOpen={onMenuOpen}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.to}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleFriday.${index}.to`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option
                                                value={item.time}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {values.scheduleFriday.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .scheduleFriday[0]
                                                            .from !== "" ? (
                                                            <img
                                                              onClick={() =>
                                                                removefirstArray(
                                                                  "scheduleFriday",
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                      {/* </td> */}
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                            {/* <td> */}
                                            <div className="w-100 d-flex justify-content-around align-items-center">
                                              <span
                                                onClick={() =>
                                                  push({ from: "", to: "" })
                                                }
                                                className="span-tag pointer"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                              <a
                                                href="#copy-modal"
                                                // data-toggle="modal"
                                                // data-target="#copy-modal"
                                                onClick={() =>
                                                  setActiveCopy("friday")
                                                }
                                                className="span-tag pointer"
                                              >
                                                {t("weekly.copyLink")}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                        // </td>
                                      )}
                                    </FieldArray>
                                  </tr>
                                  <tr>
                                    <td>
                                      <div class="form-group">
                                        <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="daysaturday"
                                          checked={
                                            values.daysaturday ||
                                            values.scheduleSaturday[0].from !== ""
                                          }
                                          type="checkbox"
                                          name="daysaturday"
                                          id="daysaturday"
                                        />
                                        <label for="daysaturday">{t("days.saturday")}</label>
                                      </div>
                                    </td>
                                    <FieldArray name="scheduleSaturday">
                                      {({ insert, remove, push }) => (
                                        <td colspan="3">
                                          <div className="d-flex">
                                            <div className="">
                                              {values.scheduleSaturday.length >
                                                0 &&
                                                values.scheduleSaturday.map(
                                                  (schedule, index) => (
                                                    <div className="d-flex justify-content-between width-530-px mb-2">
                                                      {/* <td> */}
                                                      <div class="select-dropdown">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleSaturday.${index}.from`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleSaturday.${index}.from`,
                                                              values,
                                                              "scheduleSaturday",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList}
                                                          onMenuOpen={values.scheduleSaturday[index].from === "" ? () =>
                                                            scrollMenuToTarget(
                                                              "from", "day"
                                                            ) : onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from", "day"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.from}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.from}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleSaturday.${index}.from`}
                                          />
                                          <datalist id="hours">
                                            {slotsArray.map((item) => (
                                              <option
                                                value={item.time}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                      </div>
                                                      {/* </td> */}
                                                      {/* <td> */}
                                                      <div class="select-dropdown  d-flex">
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`scheduleSaturday.${index}.to`}
                                                          onChange={(value) =>
                                                            customChangeHandler(
                                                              index,
                                                              value,
                                                              setFieldValue,
                                                              `scheduleSaturday.${index}.to`,
                                                              values,
                                                              "scheduleSaturday",
                                                              "to",
                                                              values.scheduleSaturday[index].from
                                                            )
                                                          }
                                                          onBlur={handleBlur}

                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                schedule.from
                                                                  .value
                                                              )
                                                          )}
                                                          // options={slotsList}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to", "day"
                                                          //   )
                                                          // }
                                                          onMenuOpen={onMenuOpen}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          value={schedule.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                        {/* <input
                                            list="hours"
                                            value={schedule.to}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Hours"
                                            name={`scheduleSaturday.${index}.to`}
                                          />
                                          <datalist id="hours">
                                            {makeHours(24).map((item) => (
                                              <option
                                                value={formatTime(item)}
                                              ></option>
                                            ))}
                                          </datalist> */}
                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {values.scheduleSaturday.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .scheduleSaturday[0]
                                                            .from !== "" ? (
                                                            <img
                                                              onClick={() =>
                                                                removefirstArray(
                                                                  "scheduleSaturday",
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                      {/* </td> */}
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                            {/* <td> */}
                                            <div className="w-100 d-flex justify-content-around align-items-center">
                                              <span
                                                onClick={() =>
                                                  push({ from: "", to: "" })
                                                }
                                                className="span-tag pointer"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                              <a
                                                href="#copy-modal"
                                                // data-toggle="modal"
                                                // data-target="#copy-modal"
                                                onClick={() =>
                                                  setActiveCopy("saturday")
                                                }
                                                className="span-tag pointer"
                                              >
                                                {t("weekly.copyLink")}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                        // </td>
                                      )}
                                    </FieldArray>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* adding specific dates accordion */}
              {/* {schedule_id !== "" && ( */}

              <div className="calendar-box-new">
                <div id="accordion">
                  <div class="card-modify">
                    <div class="card-header" id={"heading-1"}>
                      <h5 class="mb-0">
                        <a
                          class="collapsed"
                          role="button"
                          data-toggle="collapse"
                          href={"#collapse-2"}
                          aria-expanded="false"
                          aria-controls={"collapse-2"}
                        >
                          {""}
                          {checkIsGroupSessionTitles(values, t("specificDates.groupTitle"), t("specificDates.title"))}{" "}
                          {/* {"Add Hours for Specific Dates"}{" "} */}
                        </a>
                      </h5>

                      <div
                        id={"collapse-2"}
                        class="collapse"
                        data-parent="#accordion"
                        aria-labelledby={"heading-1"}
                      >
                        <div class="card-body">
                          {!showSpecificAddDates && (
                            <div className="right-last-td nonediv  ml-5">
                              <button
                                className="pointer"
                                type="reset"
                                onClick={() => setShowSpecificAddDates(true)}
                              >
                                {t("specificDates.addNewDate")}
                              </button>
                            </div>
                          )}
                          {showSpecificAddDates &&
                            values.specificDateSlots.length > 0 &&
                            values.specificDateSlots.map((schedule, index) => (
                              <div className="mt-4 mb-4 specific-specific-blocked-date">
                                <FieldArray name="specificDateSlots">
                                  {({ insert, remove, push }) => (
                                    <>
                                      <div className="addspecifce">
                                        <div className="clander-popup">
                                          <div className="box-valid-from-two">
                                            <div id="filterDate2">
                                              <div className="tab2-row">
                                                <div
                                                  class="input-group date newadddate"
                                                  data-date-format="dd.mm.yyyy"
                                                >
                                                  <input
                                                    type="date"
                                                    class="form-control"
                                                    // placeholder="dd.mm.yyyy"
                                                    value={schedule.date}
                                                    onChange={(e) => onCustomdateChangeHandler(e, 'specific', `specificDateSlots.${index}.date`, setFieldValue)}
                                                    onBlur={handleBlur}
                                                    name={`specificDateSlots.${index}.date`}
                                                    max={values.end_date}
                                                    min={moment().format('YYYY-MM-DD')}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <FieldArray
                                        name={`specificDateSlots.${index}.time`}
                                      >
                                        {({ insert, remove, push }) => (
                                          <div className="d-flex">
                                            <div className="">
                                              {schedule.time.length > 0 &&
                                                schedule.time.map(
                                                  (time, index1) => (
                                                    <div className="d-flex justify-content-between width-354-px mb-2 ml-3">
                                                      <div class="select-dropdown time-claas">
                                                        <span class="start_time">{t("time.startTime")}</span>
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`specificDateSlots.${index}.time.${index1}.from`}
                                                          onChange={(value) =>
                                                            // setFieldValue(
                                                            //   `specificDateSlots.${index}.time.${index1}.from`,
                                                            //   value
                                                            // )
                                                            customChangeHandler(
                                                              index1,
                                                              value,
                                                              setFieldValue,
                                                              `specificDateSlots.${index}.time.${index1}.from`,

                                                              values,
                                                              "specificDateSlots",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}
                                                          closeMenuOnSelecttrue={
                                                            false
                                                          }
                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList}
                                                          onMenuOpen={values.specificDateSlots[index].time[index1].from == "" ? () =>
                                                            scrollMenuToTarget(
                                                              "spec_block_date", "day"
                                                            ) : onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          value={time.from}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {
                                                                    slotsList.value
                                                                  }
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                      </div>

                                                      <div class="select-dropdown time-claas">
                                                        <span class="end_time">{t("time.endTime")}</span>
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`specificDateSlots.${index}.time.${index1}.to`}
                                                          onChange={(value) =>
                                                            // setFieldValue(
                                                            //   `specificDateSlots.${index}.time.${index1}.to`,
                                                            //   value
                                                            // )
                                                            customChangeHandler(
                                                              index1,
                                                              value,
                                                              setFieldValue,
                                                              `specificDateSlots.${index}.time.${index1}.to`,

                                                              values,
                                                              "specificDateSlots",
                                                              "to",
                                                              values.specificDateSlots[index].time[index1].from
                                                            )
                                                          }
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          onBlur={handleBlur}
                                                          closeMenuOnSelecttrue={
                                                            false
                                                          }
                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                time.from.value
                                                              )
                                                          )}
                                                          // options={slotsList}
                                                          onMenuOpen={onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          value={time.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />

                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {schedule.time.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index1)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .specificDateSlots[
                                                            index
                                                          ].time[0].from !==
                                                            "" ? (
                                                            <img
                                                              onClick={() =>
                                                                removefirstArray(
                                                                  `specificDateSlots.${index}.time`,
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                            {!showGroupSession && (
                                              <div className="fullDay-checkbox">
                                                <input
                                                  onChange={(e) =>
                                                    onChangeFulldayHandler(
                                                      e,
                                                      "specific",
                                                      values,
                                                      setFieldValue
                                                    )
                                                  }
                                                  checked={specificfullday ? true : false}
                                                  type="checkbox"
                                                  value={"fullday"}
                                                  name="fullday"
                                                  id="fullday"
                                                />
                                                <label
                                                  className="mr-3"
                                                  for="fullday"
                                                >
                                                  {t("specificDates.fullDay")}
                                                </label>
                                              </div>
                                            )}
                                            <div className="w-100 d-flex justify-content-around align-items-center ml-5">

                                              <span

                                                onClick={!specificfullday ? () =>
                                                  push({ from: "", to: "" }) : () => { }
                                                }
                                                className="span-tag pointer margin-unset padding-left-hours"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>
                                            </div>

                                          </div>
                                        )}
                                      </FieldArray>
                                      <div className="ml-5 action-btn-blocked-specific">
                                        <div className="right-last-td">
                                          {index > 0 ? (
                                            <button
                                              onClick={() => remove(index)}
                                              type="button"
                                              className="pointer"
                                            >
                                              <img src="images/close.png"></img>
                                              {t("actions.remove")}
                                            </button>
                                          ) : values.specificDateSlots[0].date !==
                                            "" ||
                                            values.specificDateSlots[0].time[0]
                                              .from !== "" ? (
                                            <button
                                              onClick={() =>
                                                removefirstArrayDateSLots(
                                                  `specificDateSlots`,
                                                  setFieldValue
                                                )
                                              }
                                              className="pointer"
                                              type="button"
                                            >
                                              <img src="images/close.png"></img>
                                              {t("actions.remove")}
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              className="hidden-elem"
                                            >
                                              <img src="images/close.png"></img>
                                              {t("actions.remove")}
                                            </button>
                                          )}
                                        </div>

                                        <div className="right-last-td">
                                          <button
                                            className="pointer  bg-theme-d5a67b"
                                            type="button"
                                            // type="reset"
                                            onClick={
                                              values.specificDateSlots[0].date !==
                                                "" &&
                                                values.specificDateSlots[0].time[0]
                                                  .from !== "" &&
                                                values.specificDateSlots[0].time[0]
                                                  .to !== ""
                                                ? () =>
                                                  updatdeValues(
                                                    values.specificDateSlots,
                                                    setFieldValue,
                                                    values,
                                                  )
                                                : ""
                                            }
                                          >
                                            {updateType === "ADD"
                                              ? t("specificDates.saveDate")
                                              : t("specificDates.updateDate")}
                                          </button>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            ))}

                          <div>
                            {testValues.length > 0 &&
                              testValues.map((item, index) => (
                                <div className="specific-dated-text-box">
                                  <div>{item.date}</div>
                                  <div>
                                    {item.time.map((time) => (
                                      <div className="line-height-30px">
                                        <span className="mr-2">
                                          {" "}
                                          {time.from.value}
                                          {getTimeImage(time.from.value) ? <img
                                            src="localImages/moon.png"
                                            className="star-imh-moon ml-1"
                                            alt="time-image"
                                          /> : ''}
                                        </span>{" "}
                                        -{""}
                                        <span className="ml-2">
                                          {time.to.value === "11:59 PM" ? "12:00 AM" : time.to.value}
                                          {getTimeImage(time.to.value) ? <img
                                            src="localImages/moon.png"
                                            className="star-imh-moon ml-1"
                                            alt="time-image"
                                          /> : ''}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                  <div>
                                    {" "}
                                    <div className="multiple-datepicker">
                                      <MultipleDatePicker
                                        value={"Copy"}
                                        onSubmit={(dates) =>
                                          getCopiedDates(
                                            dates,
                                            index,
                                            setFieldValue
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="right-last-td">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        onEditSpecificValue(
                                          index,
                                          setFieldValue
                                        )
                                      }
                                      className="pointer"
                                    >
                                      {t("actions.edit")}
                                    </button>
                                    &nbsp;
                                    <button
                                      type="button"
                                      onClick={() =>
                                        onDeleteSpecificValue(
                                          index,
                                          setFieldValue
                                        )
                                      }
                                      className="pointer"
                                    >
                                      {t("actions.delete")}
                                    </button>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* )} */}
              {/********
               *
               * blocked dates
               *
               *
               *
               *
               *
               *
               *
               */}
              {/* {!showGroupSession && ( */}
              <div className="calendar-box-new">
                <div id="accordion">
                  <div class="card-modify">
                    <div class="card-header" id={"heading-1"}>
                      <h5 class="mb-0">
                        <a
                          class="collapsed"
                          role="button"
                          data-toggle="collapse"
                          href={"#collapse-3"}
                          aria-expanded="false"
                          aria-controls={"collapse-3"}
                        >
                          {""}
                          {t("blockedDates.title")}{" "}
                        </a>
                      </h5>

                      <div
                        id={"collapse-3"}
                        class="collapse"
                        data-parent="#accordion"
                        aria-labelledby={"heading-1"}
                      >
                        <div class="card-body">


                            <div className="right-last-td nonediv align-add-block-section">
                              {!showBlockedAddDates && (
                              <button
                                className="pointer red-btn-block"
                                type="reset"
                                onClick={() => setShowBlockedAddDates(true)}
                              >
                                {t("blockedDates.addBlock")}
                              </button>
                              )}
                              <div className="fullDay-checkbox add-all-services-wrapper">
                              <input
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value="add_to_all_services"
                                          checked={values.add_to_all_services}
                                          defaultChecked={
                                          values.add_to_all_services ===
                                          true
                                            ? true
                                            : false
                                        }
                                          
                                          type="checkbox"
                                          name="add_to_all_services"
                                          id="add_to_all_services"
                                        />
                                        <label for="add_to_all_services" className={`add-to-all-services ${!showBlockedAddDates ? 'add-to-all-services-add-space' : 'add-to-all-services-remove-space'}`}>{t("blockedDates.addToAllServices")}</label>
                            </div>
                            </div>




                          {showBlockedAddDates &&
                            values.blockedDateSlots.length > 0 &&
                            values.blockedDateSlots.map((schedule, index) => (
                              <div className="mt-4 mb-4 specific-specific-blocked-date">
                                <FieldArray name="blockedDateSlots">
                                  {({ insert, remove, push }) => (
                                    <>
                                      <div className="addspecifce">
                                        <div className="clander-popup">
                                          <div className="box-valid-from-two">
                                            <div id="filterDate2">
                                              <div className="tab2-row">
                                                <div
                                                  class="input-group date newadddate date-wrapper"
                                                  data-date-format="dd.mm.yyyy"
                                                >
                                                  
                                                 
                                                    <input
                                                      type="date"
                                                      className="form-control date-input"
                                                      value={schedule.date}
                                                      min={moment().format('YYYY-MM-DD')}
                                                      onChange={(e) =>
                                                        onCustomdateChangeHandler(
                                                          e,
                                                          'blocked',
                                                          `blockedDateSlots.${index}.date`,
                                                          setFieldValue
                                                        )
                                                      }
                                                      onBlur={handleBlur}
                                                      name={`blockedDateSlots.${index}.date`}
                                                    />
                                                  

                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <FieldArray
                                        name={`blockedDateSlots.${index}.time`}
                                      >
                                        {({ insert, remove, push }) => (
                                          <div className="d-flex">
                                            <div className="">
                                              {schedule.time.length > 0 &&
                                                schedule.time.map(
                                                  (time, index1) => (
                                                    <div className="d-flex justify-content-between width-354-px mb-2 ml-3">
                                                      <div class="select-dropdown time-claas">
                                                        <span className="start_time">{t("time.startTime")}</span>
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`blockedDateSlots.${index}.time.${index1}.from`}
                                                          onChange={(value) =>
                                                            // setFieldValue(
                                                            //   `blockedDateSlots.${index}.time.${index1}.from`,
                                                            //   value
                                                            // )

                                                            customChangeHandler(
                                                              index1,
                                                              value,
                                                              setFieldValue,
                                                              `blockedDateSlots.${index}.time.${index1}.from`,

                                                              values,
                                                              "blockedDateSlots",
                                                              "from"
                                                            )
                                                          }
                                                          onBlur={handleBlur}
                                                          closeMenuOnSelecttrue={
                                                            false
                                                          }
                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList}
                                                          onMenuOpen={values.blockedDateSlots[index].time[index1].from === "" ? () =>
                                                            scrollMenuToTarget(
                                                              "spec_block_date", "day"
                                                            ) : onMenuOpen}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "from"
                                                          //   )
                                                          // }
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          value={time.from}
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />
                                                      </div>

                                                      <div class="select-dropdown time-claas">
                                                        <span className="end_time">{t("time.endTime")}</span>
                                                        <Select
                                                          className="day-schedule-input font-size-17 "
                                                          menuPortalTarget={document.body}
                                                          menuPosition="fixed"
                                                          id={`blockedDateSlots.${index}.time.${index1}.to`}
                                                          onChange={(value) =>
                                                            // setFieldValue(
                                                            //   `blockedDateSlots.${index}.time.${index1}.to`,
                                                            //   value
                                                            // )
                                                            customChangeHandler(
                                                              index1,
                                                              value,
                                                              setFieldValue,
                                                              `blockedDateSlots.${index}.time.${index1}.to`,

                                                              values,
                                                              "blockedDateSlots",
                                                              "to",
                                                              values.blockedDateSlots[index].time[index1].from
                                                            )
                                                          }
                                                          filterOption={
                                                            customFilter
                                                          }
                                                          onBlur={handleBlur}
                                                          closeMenuOnSelecttrue={
                                                            false
                                                          }
                                                          closeMenuOnScroll={
                                                            false
                                                          }
                                                          options={slotsList.filter(
                                                            (option, index) =>
                                                              formatTimeTo24hrs(
                                                                option.value
                                                              ) >
                                                              formatTimeTo24hrs(
                                                                time.from
                                                                  .value
                                                              )
                                                          )}
                                                          // options={slotsList}
                                                          // onMenuOpen={() =>
                                                          //   scrollMenuToTarget(
                                                          //     "to"
                                                          //   )
                                                          // }
                                                          onMenuOpen={onMenuOpen}
                                                          placeholder={t("time.hoursPlaceholder")}
                                                          value={time.to}
                                                          formatOptionLabel={(
                                                            slotsList
                                                          ) =>
                                                            getTimeImage(
                                                              slotsList.value
                                                            ) ? (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                                &nbsp;&nbsp;
                                                                <img
                                                                  src="localImages/moon.png"
                                                                  className="star-imh-moon"
                                                                  alt="time-image"
                                                                />
                                                              </div>
                                                            ) : (
                                                              <div className="time-option">
                                                                <span>
                                                                  {slotsList.value ==
                                                                    "11:59 PM"
                                                                    ? "12:00 AM"
                                                                    : slotsList.value}
                                                                </span>
                                                              </div>
                                                            )
                                                          }
                                                        />

                                                        <div className="buttion-add-box onclick-button mt-2">
                                                          {schedule.time.length > 1 ? (
                                                            <img
                                                              onClick={() =>
                                                                remove(index1)
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : values
                                                            .blockedDateSlots[
                                                            index
                                                          ].time[0].from !==
                                                            "" ? (
                                                            <img
                                                              onClick={() =>
                                                                removefirstArray(
                                                                  `blockedDateSlots.${index}.time`,
                                                                  setFieldValue
                                                                )
                                                              }
                                                              className="pointer"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          ) : (
                                                            <img
                                                              className="hidden-elem"
                                                              src="../images/icon-b2.png"
                                                              alt={t("actions.deleteAlt")}
                                                            />
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                            </div>


                                            <div className="fullDay-checkbox">
                                              <input
                                                onChange={(e) =>
                                                  onChangeFulldayHandler(
                                                    e,
                                                    "blocked",
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                                checked={blockedfullday ? true : false}
                                                type="checkbox"
                                                value={"fulldayblock"}
                                                name="fulldayblock"
                                                id="fulldayblock"
                                              />
                                              <label
                                                className="mr-3"
                                                for="fulldayblock"
                                              >
                                                {t("specificDates.fullDay")}
                                              </label>
                                            </div>
                                            <div className="w-100 d-flex justify-content-around align-items-center ml-5">
                                              <span
                                                onClick={!blockedfullday ? () =>
                                                  push({ from: "", to: "" }) : () => { }
                                                }
                                                className="span-tag pointer margin-unset padding-left-hours"
                                              >
                                                {checkIsGroupSessionTitles(values, t("weekly.addEvent"), t("weekly.addHours"))}
                                              </span>

                                            </div>
                                          </div>
                                        )}
                                      </FieldArray>
                                      <div className="ml-5 action-btn-blocked-specific">
                                        <div className="right-last-td">
                                          {index > 0 ? (
                                            <button
                                              onClick={() => remove(index)}
                                              type="button"
                                              className="pointer"
                                            >
                                              <img src="images/close.png"></img>
                                              {t("actions.remove")}
                                            </button>
                                          ) : values.blockedDateSlots[0]
                                            .date !== "" ||
                                            values.blockedDateSlots[0].time[0]
                                              .from !== "" ? (
                                            <button
                                              onClick={() =>
                                                removefirstArrayDateSLots(
                                                  `blockedDateSlots`,
                                                  setFieldValue
                                                )
                                              }
                                              className="pointer"
                                              type="button"
                                            >
                                              <img src="images/close.png"></img>
                                              {t("actions.remove")}
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              className="hidden-elem"
                                            >
                                              <img src="images/close.png"></img>
                                              {t("actions.remove")}
                                            </button>
                                          )}

                                        </div>

                                        <div className="right-last-td">
                                          <button
                                            className="pointer bg-theme-d5a67b"
                                            type="button"
                                            // type="reset"

                                            onClick={
                                              values.blockedDateSlots[0]
                                                .date !== "" &&
                                                values.blockedDateSlots[0].time[0]
                                                  .from !== "" &&
                                                values.blockedDateSlots[0].time[0]
                                                  .to !== ""
                                                ? () =>
                                                  updatdeBlockedValues(
                                                    values.blockedDateSlots,
                                                    setFieldValue,
                                                    values,
                                                  )
                                                : ""
                                            }
                                          >
                                            {/* <img src="images/close.png"></img> */}
                                            {blockedupdateType === "ADD"
                                              ? t("specificDates.saveDate")
                                              : t("specificDates.updateDate")}
                                          </button>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </FieldArray>
                              </div>
                            ))}

                          {blockedDatesValues.length > 0 &&
                            blockedDatesValues.map((item, index) => (
                              <div className="specific-dated-text-box">
                                <div>{item.date}</div>
                                <div>
                                  {item.time.map((time) => (
                                    <div className="line-height-30px">
                                      <span className="mr-2">
                                        {" "}
                                        {time.from.value}
                                        {getTimeImage(time.from.value) ? <img
                                          src="localImages/moon.png"
                                          className="star-imh-moon ml-1"
                                          alt="time-image"
                                        /> : ''}
                                      </span>{" "}
                                      -{""}
                                      <span className="ml-2">
                                        {time.to.value === "11:59 PM" ? "12:00 AM" : time.to.value}
                                        {getTimeImage(time.to.value) ? <img
                                          src="localImages/moon.png"
                                          className="star-imh-moon ml-1"
                                          alt="time-image"
                                        /> : ''}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                                <div className="multiple-datee">
                                  {" "}
                                  <div className="multiple-datepicker">
                                    <MultipleDatePicker
                                      value={"Copy"}
                                      onSubmit={(dates) =>
                                        getBlockedCopiedDates(
                                          dates,
                                          index,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="right-last-td">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      onEditBlockedValue(index, setFieldValue)
                                    }
                                    className="pointer"
                                  >
                                    {t("actions.edit")}
                                  </button>
                                  &nbsp;
                                  <button
                                    type="button"
                                    onClick={() =>
                                      onDeleteBlockedValue(index, setFieldValue)
                                    }
                                    className="pointer"
                                  >
                                    {t("actions.delete")}
                                  </button>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* )} */}
              {/********
               *
               *
               * blocked dated
               * *
               *
               *
               *
               *
               */}

              {/*** start date and end date  start*/}
              {/* {!showGroupSession && ( */}
              <div className="row-valid-from">
                <div className="box-valid-from-one">
                  <span className="these-span">{t("validity.validFrom")}</span>
                </div>
                <div className="box-valid-from-two">
                  <div id="filterDate2">
                    <div class="input-group date" >
                      <input
                        type="date"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        data-date-format="YYYY-MM-DD"
                        value={values.start_date}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name={`start_date`}
                        min={schedule_id === "" ? moment().format('YYYY-MM-DD') : ''}
                        className={`number-input form-control ${errors.start_date &&
                          touched.start_date &&
                          errors.start_date
                          ? "error-boundry"
                          : ""
                          }`}
                      />
                    </div>
                  </div>
                  <em>{t("validity.to")}</em>
                  <div id="filterDate2">
                    <div class="input-group date" >
                      <input
                        type="date"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        data-date-format="YYYY-MM-DD"
                        value={values.end_date}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name={`end_date`}
                        min={moment().format('YYYY-MM-DD')}
                      />
                    </div>
                  </div>
                  <span>{t("validity.optional")}</span>{" "}
                </div>
              </div>
              {/* )} */}
              {/*** start date and end date end */}
              {/* adding Accordion */}

              {/* <div className="advancesettings-connect-meeting">
                <h4>Payment Setup</h4>
                <div className="payment-setup-boxx">
                  <p>
                    <input
                      type="radio"
                      id="test2"
                      name="payment_type"
                      checked={
                        parseInt(values.payment_type) === 0 ? true : false
                      }
                      value={0}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <label for="test2">Paypal</label>
                  </p>
                </div>
                {parseInt(values.payment_type) === 0 && (
                  <div className="paypaluser-filde">
                    <label>PayPal Username</label>
                    <input
                      name="payment_id"
                      value={values.payment_id}
                      type="text"
                      placeholder=""
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                  </div>
                )}
              </div> */}
              <div className="back-to-schudle-btn floating-button-back-to-schudle">

                <button type="submit" className="updatebtn updatebtn-green">
                  {t("actions.update")}
                </button>
                <button
                  type="button"
                  onClick={cancelForm}
                  className="pay-cnale"
                >
                  {t("actions.cancel")}
                </button>
              </div>
              {/* </div> */}
            </form>
          )}
        </Formik>
        <div></div>
      </div>
       <AvailabilityNotePopup
                onYesClick={onYesClick}
                onNoClick={onNoClick}
                />
      <div className="backtoschedules-modal">

        <ConfirmOffline deleteUser={confirmFormRequest} id={'ConfirmOffline'} cancelRequest={closePopup} />
        <ConfirmTime id={'ConfirmTime'} deleteUser={() => window.loadModal('#ConfirmTime', 'hide')} />
        <ConfirmSessionCurrency
          deleteUser={confirmRequest}
          cancelRequest={cancelRequest}
          id={'confirmCurrency'} />


        {/* <PreviewCheckbox id={'PreviewCheckbox'} cancelRequest={closePreviewCheckbox} deleteUser={openPreviewCheckbox} /> */}
      </div>
    </>
  );
}
